import React, { Component } from 'react';
import {connect} from 'react-redux';
import $ from 'jquery';
import ReactStars from 'react-stars';
import { Link, browserHistory } from 'react-router';
import WebHeaderInner from '../Common/WebHeaderInner.js';
import WebFooter from '../Common/WebFooter.js';
import * as actions from './../../actions';
import Web_NotFound from './../Common/Web_NotFound.js';
import { Panel, Button, Modal, Breadcrumb,OverlayTrigger,Popover } from 'react-bootstrap';
import { ShareButtons, generateShareIcon} from 'react-share';
import Swiper from 'react-id-swiper';
const parseHtml = require('html-react-parser');
import Icon, { FontAwesome, Feather } from 'react-web-vector-icons';

// Routing Parameters ::
// /web/pdetails/:BrandName/:CatName/:Title/:Pid/:Did
// /web/pdetails/:BrandName/:CatName/:Bname/:Title/:Pid/:Did

const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets//';

class Web_ProductFullDetails extends Component {
	constructor(props){
      super(props);
	  this.state={}		
		this.state={
			feedbrands: [],
		    feed_sub_cat:[],
		    feedcat: [],
		    feedsList:[],
			pid:this.props.params.Pid,
			dealid:this.props.params.Did,
			brand_name:this.props.params.BrandName,
			cat_name: this.props.params.CatName,
			p_title: this.props.params.Title,
			pdeals: [],
			offer: '',
			pro_details: [],
			pro_deal_details: [],
			offer_details:[],
			product_attributes: [],
			coupon_first: [],
			imgs: [],
			prevPath: '',
			seller_id: '',
			tags_status: false,
			attr_status: false,
			loading: false,
			tags: [],
			split_tags: [],
			open: false,
			desc_open: true,
			desc_flag: false,
			showModal: false,
			is_char: false,
			shareUrl: '',
			dtype: this.props.params.DType,
			session:localStorage.getItem('token'),
			title:'',
			desc:'',
			bestprice_desc: '',
			bestprice_status: false,
			coupons:[],
			page_error_status: false,
			web_title:'',
			web_desc:'',
			seo_desc:'',
			reqbestPrice:false,
			cpns_list:'',
			swipe_description_status: 1,
			swipe_product_attributes:[],
			desc_update_soon_status: false,

			unit_name:'',
			min_qty:0,
        	max_qty:0,
        	min_qty1:0,
        	max_qty1:0,
        	tons:0,
        	qty:'',
        	qty_err_status: false,
        	qty_err_msg:'',
        	is_cart:0,
        	clearcart_status:false,
        	cart_added_status:false,
        	addtocart_status:false,
        	updatecart_status:false,
        	addtocart_msg:'',
        	type:'',

        	free_ship_msg:'',
			user_zipcode:'',
			free_shipment:0,

			err_pincode:false,
			err_pincode_msg:'',

			cart_count:0,
			swipe_attributes_titles:[],
			swipe_attr_status:'',
			cid:'',
			no_details_attr:0,
			req_quantity:'',
			req_state:'',
			req_city:'',
			req_doorno:'',
			req_pincode:'',

			req_confirm_modal:false,
			req_confirm_message:'',
			// prev_path: window.previousLocation.pathname,
			page_loading:false,
			wishLst_flag:'',
			cat_sim_flag:'',
			brand_sim_flag:'',
			stage_sim_flag:'',
			similar_brand_deals:[],
			similar_category_deals:[],
			similar_stage_deals:[],
			similar_brand_deals_status:false,
			similar_category_deals_status:false,
			similar_stage_deals_status:false,
			bid:'',
			// Follow section
			brand_like_status:'',
			// brand_like_users:[],
			brand_likes_count:'',
			// brand_like_rem_count:'',
			brand_follow_count:'',
			// b_follow_status:false,
			show_about_brand:'',
			show_about_brand_flag:false,

			like_status_flag:'',
			isToggle:true,
			check_swipe_id:'',

			ad_assist_modal:false,
			ad_guarantee:'',
			ad_guarantee_icon:'',
			ad_asst_time:'',
			ad_asst_confirm_message:'',
			ad_asst_confirm_modal:false,
			ad_grnt_str:'',

			rotateClass:false,
			cart_qty:0,
			d_type_bread:'',

			recommended:'',
			rating:'',
			// dealid:'',

			deal_did:'',

			brand_desc:'',
			order_msg:'',
			show_order_count_flag:'',
			queries:[],
			product_tabs_avail:false,
			best_price_txt:'',			
			disclaimer_flag:false,
			disclaimer_txt:'',
			visibility:false,
			// rotate:false,
		}
		this.ShareFunc=this.ShareFunc.bind(this);
		this.close=this.close.bind(this);
		this.getDeviceId=this.getDeviceId.bind(this);
		this.getswipeDescription=this.getswipeDescription.bind(this);

		this.decrementMinQty=this.decrementMinQty.bind(this);
		this.updateMinQty=this.updateMinQty.bind(this);
		this.incrementMinQty=this.incrementMinQty.bind(this);
		this.placeOrderModal=this.placeOrderModal.bind(this);
		this.removeCartItems=this.removeCartItems.bind(this);

		this.pincodeChange=this.pincodeChange.bind(this);
  		this.checkPincode=this.checkPincode.bind(this);

  		this.getCartCount=this.getCartCount.bind(this);
  		//this.getAttributesTitle=this.getAttributesTitle.bind(this);
  		//this.getswipeDescription_Initial=this.getswipeDescription_Initial.bind(this);

  		this.checkBestPrice=this.checkBestPrice.bind(this);
  		this.reqBestPriceSubmit=this.reqBestPriceSubmit.bind(this);
  		
  		this.req_quantityChange=this.req_quantityChange.bind(this);
  		this.req_stateChange=this.req_stateChange.bind(this);
  		this.req_cityChange=this.req_cityChange.bind(this);
  		this.req_doornoChange=this.req_doornoChange.bind(this);
  		this.req_pincodeChange=this.req_pincodeChange.bind(this);

  		this.addToWishlist=this.addToWishlist.bind(this);
  		this.tokenCheck=this.tokenCheck.bind(this);

  		this.getSimilarBrandDeals=this.getSimilarBrandDeals.bind(this);
		this.getSimilarCatDeals=this.getSimilarCatDeals.bind(this);
		this.getSimilarStageDeals=this.getSimilarStageDeals.bind(this);
		// this.FollowBrand=this.FollowBrand.bind(this);
		this.submitAdAssistData=this.submitAdAssistData.bind(this);
		this.getAdAssistModal=this.getAdAssistModal.bind(this);
		this.setAdTime=this.setAdTime.bind(this);
		this.addToCartOnload=this.addToCartOnload.bind(this);
		this.checkBestPriceOnload=this.checkBestPriceOnload.bind(this);
		this.addtowishlistOnload=this.addtowishlistOnload.bind(this);
		this.likeBrandOnload=this.likeBrandOnload.bind(this);

		this.goNext = this.goNext.bind(this);
    	this.goPrev = this.goPrev.bind(this);

    	this.addQCart =this.addQCart.bind(this);
    	this.addQCart_Onload=this.addQCart_Onload.bind(this);
	}
	componentDidMount()
	{
		window.scrollTo(0, 0);				
	    localStorage.removeItem('w_r_s_dt');
	    localStorage.removeItem('w_r_e_coupon_dt');
	    localStorage.removeItem('w_r_e_s_dt');
	    localStorage.removeItem('web_mycart');
	    localStorage.removeItem('w_r_enq_seller_page');

	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('web_ofr_page');
	    localStorage.removeItem('profile');
	    localStorage.removeItem('myaquacash');
	    localStorage.removeItem('web_share_earn');
	    localStorage.removeItem('checkout');
	    localStorage.removeItem('order_details');
	    localStorage.removeItem('myorders');
	    localStorage.removeItem('w_r_p_deals');
	    localStorage.removeItem('seed');
	    localStorage.removeItem('nauplii');
	    localStorage.removeItem('subdeals');
	    localStorage.removeItem('shipping');
	    localStorage.removeItem('notifications');
	
	    localStorage.removeItem('view_rating');
	    localStorage.removeItem('w_modal_seed');
	    localStorage.removeItem('w_r_seed_deals');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('w_modal_details');
	    localStorage.removeItem('offers');
	    localStorage.removeItem('give_rating');
	    localStorage.removeItem('pprice');
	    localStorage.removeItem('sprice');
	    localStorage.removeItem('seed_id');
	    localStorage.removeItem('h_type');
	    localStorage.removeItem('web_pro_ofr_dtls');
	    localStorage.removeItem('web_wishlist');
	    localStorage.removeItem('web_brand_details');

	    localStorage.removeItem('m_r_s_dt');
	    localStorage.removeItem('m_r_e_coupon_dt');
	    localStorage.removeItem('m_r_e_s_dt');
	    localStorage.removeItem('mob_mycart');
	    localStorage.removeItem('m_r_enq_seller_page');
	    localStorage.removeItem('m_r_p_dt');
	    localStorage.removeItem('m_r_e_p_dt');
	    localStorage.removeItem('ofr_page');
	    localStorage.removeItem('pro_ofr_dtls');

	    localStorage.removeItem('share_earn');
	    localStorage.removeItem('my_orders');
	    localStorage.removeItem('m_r_p_deals');
	    localStorage.removeItem('mob_quickcart');
	    localStorage.removeItem('partner_deals');
			
		if(screen.width < 800)
		{
			if(this.props.params.Bname)
			{
				window.location.href='/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did;
			}
			else
			{
				window.location.href='/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did;
			}
		}
		// if(!localStorage.token && !localStorage.user_id)
		// {
		// 	localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);
		// 	browserHistory.push('/web/login');
		// 	window.location.reload();
		// }
		
		this.getDeviceId();
		//this.getAttributesTitle();
		this.getCartCount();
		// this.getswipeDescription(1);
		if(this.props.params.Bname)
		{
			localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);
		}
		else
		{
			localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);
		}

		if(localStorage.user_id)
		{
			var uid=localStorage.user_id;
		}
		else
		{
			uid=0;
		}
		var url=window.location.href;

		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		var data1={from:'desktop_web',uid:uid,token:localStorage.getItem('token'),id:this.state.pid,deal_id:this.props.params.Did,lati: localStorage.getItem('lati'),longi: localStorage.getItem('longi'),url:url,source:source,campaign:campaign,url_id:url_id};
	    var data2=JSON.stringify(data1);
	 	$.ajax({
	        method: 'POST',
	        url: baseUrl+'getProductDetails',
	        dataType:'json',
	        data: {req:data2},
	        success: function(data)
	        {
	          	if(data.status === "error")
	          	{
	          		this.setState({
	          			page_error_status: true,
	          		});
	          		window.location.href=data.redirect;
	          	}
	          	if(data.message === "Token mismatch")
	          	{
	      			localStorage.removeItem('token');
	      		 	localStorage.removeItem('user_id');
	      		 	// browserHistory.push('/web/login');
	      		 	window.location.reload();
	      		}
	      		this.setState({
	          		is_char: data.is_char,
	          	})
				var t= $.makeArray(data.tags);
		        // if(data.product_attributes.length > 0)
		        // {
		        //  	this.setState({
		        //  		product_attributes: data.product_attributes[0].chars,
		        //  	})
		        // }
		        var s = $.makeArray(data.pro_details);
		        var o = $.makeArray(data.offer_details);
		        localStorage.setItem('d_type',s[0].dtype);
		        this.setState({
			       	loading:true,
			       	page_id: localStorage.getItem('cat_page'),
			      	offer: data,
			      	pdeals: data.pro_deal_details,
			      	pro_details: s[0],
		          	dtype: s[0].dtype,
		          	pro_deal_details:data.pro_deal_details[0],
		          	offer_details: o[0],
		          	// product_attributes: data.product_attributes[0].chars,
		          	imgs: data.pro_imgs,
		          	coupon_first: data.coupons[0],
		          	seller_id: data['pro_deal_details'][0]['seller_id'],
		          	tags: t[0]['tag'],
		          	title:s[0].title+" "+s[0].unit_pack+" "+s[0].brand_name,
					bread_tid:s[0].category_id,	
	                desc:s[0].description,
	                coupons:data.coupons,
	                cpns_list: data.cpns_list,
	                web_title: s[0].title + " " + s[0].unit_pack+" - "+s[0].brand_name,
	          		web_desc:s[0].description,
	          		seo_title: s[0].title + " " + s[0].unit_pack+" - "+s[0].brand_name+" | AquaDeals" ,
	          		seo_desc: "Choose the Best deal on "+s[0].brand_name +" "+s[0].title+" product from our partners and avail free shipment on online purchase",

	          		cart_qty:data.cart_qty,
	          		min_qty:data.min_qty,
		          	max_qty:data.max_qty,
		          	min_qty1:data.min_qty,
		          	max_qty1:data.max_qty,
		          	qty:data.qty,
		          	unit_name:data.unit_name,
		          	type:data.type,
		          	is_cart:data.is_cart,

		          	free_ship_msg:data.free_ship_msg,
					user_zipcode:data.user_zipcode,
					free_shipment:data.free_ship_flag,
					d_type_bread:s[0].dtype,
					wishLst_flag:data.wishLst_flag,
					cat_sim_flag:data.cat_sim_flag,
					brand_sim_flag:data.brand_sim_flag,
					stage_sim_flag:data.stage_sim_flag,
					bid:data.bid,
					brand_like_status:s[0].brand_like_status,
					// brand_like_users:data.brand_like_users,
					brand_likes_count:data.brand_likes_count,
					// brand_like_rem_count:data.brand_like_rem_count,
					brand_follow_count:data.brand_follow_count,

					ad_guarantee:data.ad_guarantee,
					ad_guarantee_icon:data.ad_guarantee_icon,
					ad_grnt_str:data.ad_grnt_str,
                    
					recommended:data.recommended,
		            rating:data.pro_details.over_rating, 
		            dealid:data.pro_deal_details[0].deal_id,
                    //the below id is deal_id of product,this is using for share url,replacecart,cart function calls 
		            deal_did:data.pro_deal_details[0].id,
					brand_desc:data.pro_details.brand_desc,
					order_msg:data.order_count,
					show_order_count_flag:data.show_order_count,
					previous_order: data.previous_order,
					best_price_txt:data.best_price_txt,
					disclaimer_flag :data.disclaimer_flag,
					disclaimer_txt: data.disclaimer_txt										
		          });
		       
		        if(data.brand_sim_flag && data.cat_sim_flag && data.stage_sim_flag)
		        {
		        	
		        	this.setState({
		        		similar_brand_deals_status:true,
		        	});
		        	this.getSimilarBrandDeals();
		        }
		        else if(!data.brand_sim_flag && data.cat_sim_flag)
		        {
		        	this.setState({
		        		similar_category_deals_status:true,
		        	})
		        	this.getSimilarCatDeals();
		        }
		        else if(!data.brand_sim_flag && !data.cat_sim_flag && data.stage_sim_flag)
		        {
		        	this.setState({
		        		similar_stage_deals_status:true,
		        	});
		        	this.getSimilarStageDeals();
		        }

		        if(data.cart_qty > 0)
		        {
		        	this.setState({
		        		min_qty:data.cart_qty,
		        	});
		        }
		        if(data.show_about_brand===1)
				{
					this.setState({
						show_about_brand_flag:true,
					});
				}
				else
				{
					this.setState({
						show_about_brand_flag:false,
					});
				}
			    if(this.state.unit_name==="kg")
	         	{
	         		this.setState({
	         			tons: parseFloat(data.pro_deal_details[0]['min_qty'] * s[0]['qty'] / 1000).toFixed(1),
	         		});
	         	}
	         	if(this.state.unit_name==="gm")
	         	{
	         		this.setState({
	         			tons: parseFloat((data.pro_deal_details[0]['min_qty'] * s[0]['qty'] / 1000) /1000).toFixed(1),
	         		});
	         	}
	         	if(data.is_cart === 1)
         		{
         			this.setState({
         				addtocart_msg:'Go to Cart',
         				addtocart_status:true,
         			});
         		}
         		else
         		{
         			this.setState({
         				addtocart_msg:'Add to Cart',
         			});
         		}
         		if(this.state.unit_name==="kg"){
					this.setState({
			 			min_qty :  parseInt(this.state.min_qty1,10),
			 			tons: this.state.min_qty * this.state.qty / 1000
		 			});	         			
         		}else if(this.state.is_cart===0 && this.state.unit_name==="gm")
					{
						this.setState({
				 			min_qty :  parseInt(this.state.min_qty1,10),
				 			tons: parseFloat((this.state.min_qty * this.state.qty /1000) / 1000).toFixed(7)
			 			});
				}else if(this.state.is_cart===1 && this.state.unit_name!=="nos")
					{
						this.setState({
				 			min_qty :  parseInt(this.state.min_qty1,10),
				 			tons: this.state.min_qty * this.state.qty / 1000
				 			// addtocart_status:false,
			 			});	
					}
         		// if(s[0].brand_follow_status==='1')
         		// {
         		// 	this.setState({
         		// 		b_follow_status:true,
         		// 	});
         		// }
		        document.title =this.state.seo_title;
		        document.getElementsByTagName("META")[2].content=this.state.seo_desc;
				
				// this.getSimilarBrandDeals();
			}.bind(this),
	        error: function(err)
	        {
	        }
	    });

		if(localStorage.user_id && localStorage.token && localStorage.addtocart)
		{
			// setTimeout(() => {this.addToCartOnload()}, 10000);
			this.addToCartOnload();
		}
		if(localStorage.user_id && localStorage.token && localStorage.checkbestprice)
		{
			this.checkBestPriceOnload();
		}
		if(localStorage.user_id && localStorage.token && localStorage.web_addtowishlist)
		{
			this.addtowishlistOnload();
		}
		if(localStorage.user_id && localStorage.token && localStorage.adAssist)
		{
			this.getAdAssistModal();
		}

		if(localStorage.user_id && localStorage.token && localStorage.web_likebrand)
		{
			this.likeBrandOnload();
		}
		if(localStorage.user_id && localStorage.token && localStorage.quickbuy_onload)
		{
			this.addQCart_Onload();
		}
	}
	componentWillReceiveProps(nextProps)
	{
        if (nextProps.location.pathname !== this.props.location.pathname) {
            window.location.reload();
        }
	};
	componentWillMount() {
        const {getProductTabs} = this.props;
        getProductTabs(this.state.pid);
        //this.props.getProductDesc(this.state.pid,nextProps.product_tabs.result[0].cid);
    }

	componentDidUpdate(prevProps){
	  // compare prevProps to current props and update
	  if(this.props.product_tabs !== prevProps.product_tabs) {

	  			this.props.getProductDesc(this.state.pid,this.props.product_tabs.result[0].cid);
	  				this.setState({
		          		swipe_attributes_titles:this.props.product_tabs.result,
		          		cid:this.props.product_tabs.result[0].cid,
		          		swipe_attr_status:this.props.product_tabs.result[0].cid,
		          		product_tabs_avail:true,
		          	});
	    }
	
	  if(this.props.product_desc !== prevProps.product_desc) {
		    			this.setState({
		    				swipe_desc_info: this.props.product_desc.desc,
		    				// swipe_product_attributes:[],
		    				// swipe_attr_status:this.props.product_tabs.result[0].cid,
		    				// check_swipe_id:this.props.product_tabs.result[0].cid,
		    			});
	    }
	
	  }


	addQCart(dealid)
	{
		if(!localStorage.user_id && !localStorage.token)
		{
			var quantity='';
			if(this.refs.input_minqty.value < parseInt(this.state.min_qty1,10) || this.refs.input_minqty.value==="NaN")
			{
				this.setState({
					qty_err_status: true,
					qty_err_msg: "* Minimum Quantity is "+this.state.min_qty1,
				});
				quantity=this.state.min_qty1;
			}
			else if(this.refs.input_minqty.value > parseInt(this.state.max_qty1,10))
			{
				this.setState({
					qty_err_status:true,
					qty_err_msg:"* Maximum Quantity is "+this.state.max_qty1,
				})
				quantity=this.state.max_qty1;
			}
			else
			{
				if(this.props.params.Bname)
				{
					localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);	
				}
				else
				{
					localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);					
				}
				// localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);
				localStorage.setItem('quickbuy_onload','1');
				localStorage.setItem('quickbuy_deal_id',dealid);
				localStorage.setItem('quickbuy_qty',this.refs.input_minqty.value);
				browserHistory.push('/web/login');
			}
		}
		// if(!localStorage.user_id && !localStorage.token)
		// {
		// 	localStorage.setItem('web_quickcart','/web/quickcart');
		// 	localStorage.setItem('quickbuy_onload','1');
	 	// 	localStorage.setItem('quickbuy_deal_id',dealid);
	 	//  browserHistory.push('/web/login');
		// }
		else
		{
			if(localStorage.user_id)
			{
				var uid=localStorage.user_id;
			}
			else
			{
				uid=0;
			}
			if(localStorage.quickbuy_qty)
			{
				var quantity=localStorage.quickbuy_qty;
			}
			else
			{
				quantity='';
			}
			var data1={from:'desktop_web',id:uid,token:localStorage.token,deal_id:dealid,quantity:quantity,deal_type:1};
	        var data2=JSON.stringify(data1);
	         $.ajax({
	         	url:baseUrl+'addToQCart',
	         	method:'POST',
	         	data:{req:data2},
	         	dataType:'JSON',
	         	success:function(data)
	         	{
					if(data.status === 'success')
	                {
	                    browserHistory.push('/web/quickcart');
	                    localStorage.removeItem('quickbuy_onload');
			            localStorage.removeItem('quickbuy_deal_id');
			            localStorage.removeItem('quickbuy_qty');
	                }
	                else if(data.status === 'error' && data.cart_flag ===0)
	                {
	                  	this.setState({clearcart_status:true,});
	                  	localStorage.removeItem('quickbuy_onload');
			            localStorage.removeItem('quickbuy_deal_id');
			            localStorage.removeItem('quickbuy_qty');
	                }
	                else if(data.status === 'error' && data.message === 'Token mismatch')
	                {
	                  	this.tokenCheck();
	                  	localStorage.removeItem('quickbuy_onload');
			            localStorage.removeItem('quickbuy_deal_id');
			            localStorage.removeItem('quickbuy_qty');
	                }
	                else if(data.status==="error" && data.message==="Product already added to the cart")
					{
						this.setState({
							already_added_status: true,
						});
						localStorage.removeItem('quickbuy_onload');
			            localStorage.removeItem('quickbuy_deal_id');
			            localStorage.removeItem('quickbuy_qty');
					}
				}.bind(this),
	         	error:function(err)
	         	{

	         	}
	        });		 
	    }
	}
	addQCart_Onload()
	{
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('web_quickcart','/web/quickcart');
			browserHistory.push('/web/login');
		}
		else
		{
			if(localStorage.user_id)
			{
				var uid=localStorage.user_id;
			}
			else
			{
				uid=0;
			}
			if(localStorage.quickbuy_deal_id)
			{
				var dealid=localStorage.quickbuy_deal_id;
			}
			else
			{
				dealid=0;
			}
			if(localStorage.quickbuy_qty)
			{
				var quantity=localStorage.quickbuy_qty;
			}
			else
			{
				quantity='';
			}
			var data1={from:'desktop_web',id:uid,token:localStorage.token,quantity:quantity,deal_id:dealid,deal_type:1};
	        var data2=JSON.stringify(data1);
	         $.ajax({
	         	url:baseUrl+'addToQCart',
	         	method:'POST',
	         	data:{req:data2},
	         	dataType:'JSON',
	         	success:function(data)
	         	{
				  if(data.status === 'success')
                  {
                    	browserHistory.push('/web/quickcart');
                    	window.location.reload();
						localStorage.removeItem('quickbuy_onload');
		            	localStorage.removeItem('quickbuy_deal_id');
		            	localStorage.removeItem('quickbuy_qty');
                  }
                  else if(data.status === 'error' && data.cart_flag ===0)
                  {
                  		this.setState({clearcart_status:true,});
                  		localStorage.removeItem('quickbuy_onload');
		            	localStorage.removeItem('quickbuy_deal_id');
		            	localStorage.removeItem('quickbuy_qty');
                  }
                  else if(data.status === 'error' && data.message === 'Token mismatch')
                  {
                  	this.tokenCheck();
                  	localStorage.removeItem('quickbuy_onload');
		            localStorage.removeItem('quickbuy_deal_id');
		            localStorage.removeItem('quickbuy_qty');
                  }
                  else if(data.status==="error" && data.message==="Product already added to the cart")
				  {
					 this.setState({
						already_added_status: true,
					 });
					 localStorage.removeItem('quickbuy_onload');
		             localStorage.removeItem('quickbuy_deal_id');
		             localStorage.removeItem('quickbuy_qty');
				  }
				  localStorage.removeItem('quickbuy_onload');
		          localStorage.removeItem('quickbuy_deal_id');
		          localStorage.removeItem('quickbuy_qty');
	         	}.bind(this),
	         	error:function(err)
	         	{

	         	}
	         
	         });		 
	    }
	}
	getCartCount()
  	{
        if(localStorage.user_id)
		{
			var uid=localStorage.user_id;
		}
		else
		{
			uid=0;
		}
        var data1={from:'desktop_web',id:uid,token:localStorage.getItem('token')};
        var data2=JSON.stringify(data1);
        $.ajax({
	        method: 'POST',
	        url: baseUrl+'cart_count',
	        dataType:'json',
	        data: {req:data2},
	        success: function(data)
	        {
	            this.setState({
	                cart_count:data.cart_count,
	            });
	        }.bind(this),
	        error: function(err)
	        {
	        }
        });
  	}
  	goNext()
	{
	    if(this.swiper) this.swiper.slideNext()
	}
	goPrev()
	{
    	if(this.swiper) this.swiper.slidePrev()
  	}
  	tokenCheck()
  	{
  		if(localStorage.source)
	  	{
	    	var source=localStorage.getItem('source');
	  	}
	  	if(localStorage.campaign)
	  	{
	    	var campaign=localStorage.getItem('campaign');
	  	}
		if(localStorage.url_id)
		{
		    var url_id=localStorage.getItem('url_id');
		}
		  // localStorage.removeItem('user_id');
		  // localStorage.removeItem('token');
		localStorage.clear();
	  	if(source)
	  	{
	    	localStorage.setItem('source',source);
	  	}
	  	if(campaign)
	  	{
	    	localStorage.setItem('campaign',campaign);
	  	}
	  	if(url_id)
	  	{
	    	localStorage.setItem('url_id',url_id);
	  	}
	  	window.location.reload();
  	}
	getDeviceId()
	{
	    if(localStorage.user_id)
	    {
	        var uid=localStorage.user_id;
	    }
	    else
	    {
	      uid=0;
	    }
	    var data1={from:'desktop_web',id:uid,device_id:localStorage.getItem('push_device_id')}
	    var data2=JSON.stringify(data1);
	    $.ajax({
	        method: 'POST',
	        url: baseUrl+'getDeviceId',
	        dataType: 'json',
	        data:{req: data2},
	        success: function(data)
	        {
	          
	        },
	        error: function(err)
	        {
	        }
	    });
	}
	close()
	{
		this.setState({
			showModal: false,
			clearcart_status:false,
			reqbestPrice:false,
			req_confirm_modal:false,
			cart_added_status:false,
			ad_assist_modal:false,
			ad_asst_confirm_modal:false,
		});
	}
	pincodeChange()
	{
		var invalidChars = /[^0-9]/gi;
	    if(invalidChars.test(this.refs.pincode.value)) 
	    {
	        var x = this.refs.pincode.value.replace(invalidChars,"");
	    }
	    else
	    {
	        this.setState({
	          err_pincode: true,
	        });
	    }
	    this.setState({
			user_zipcode:x,
			err_pincode:false,
		});
	}
	checkPincode()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.user_id;
		}
		else
		{
			uid=0;
		}
		if(this.refs.pincode.value.length ===6)
		{
			var data1={from: 'desktop_web',id:uid,token:localStorage.getItem('token'),type:1,did:this.props.params.Did,zip:this.refs.pincode.value,device_id:localStorage.getItem('push_device_id')}
		    var data2=JSON.stringify(data1);
		    $.ajax({
		        method: 'POST',
		        url: baseUrl+'checkFreeshipment',
		        dataType: 'json',
		        data:{req: data2},
		        success: function(data)
		        {
		          	this.setState({
		          		free_ship_msg:data.msg,
		          	});
		          	if(data.status==='error' && data.message==='Token mismatch')
					{
						this.props.tokenCheck();
					}
		        }.bind(this),
		        error: function(err)
		        {
		        
		        }
		    });
		}
		else
		{
			this.setState({
				err_pincode:true,
				err_pincode_msg:'* Invalid pincode',
			});
		}
	}
	removeCartItems()
	{
  		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		if(localStorage.user_id)
		{
			var uid=localStorage.user_id;
		}
		else
		{
			uid=0;
		}
		var data1={from:'desktop_web',id:uid,token:localStorage.getItem('token'),deal_id:this.state.deal_did,deal_type:1,quantity:this.refs.input_minqty.value,pl_size:0,salinity:0,pickup_date:0,source:source,campaign:campaign,url_id:url_id}
	    var data2=JSON.stringify(data1);
	    $.ajax({
			method:'post',
			dataType:'json',
			url: baseUrl+'replaceCart',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==="success" && data.cart_flag===1)
				{
					this.setState({
						addtocart_msg:'Go to Cart',
						clearcart_status:false,
						addtocart_status:true,
					});
					this.getCartCount();
				}
				if(data.status==='error' && data.message==='Token mismatch')
				{
					this.props.tokenCheck();
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
  	}
	reqBestPriceSubmit(event)
	{
		event.preventDefault();
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		var quantity = this.refs.req_quantity.value;
		var state = this.refs.req_state.value;
		{/*var city = this.refs.req_city.value;
		var doorno = this.refs.req_doorno.value;*/}
		var pincode=this.refs.req_pincode.value;
		var flag=0;
		const namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
		if(quantity==='' && quantity.length < 1)
		{
			$('#req_quantity_err').text('* Enter quantity');
			flag =1;
		}

		if(quantity !=='' &&  parseInt(quantity) < parseInt(this.state.pro_deal_details.best_price_min_qty))
		{
			$('#req_quantity_err').text('* Minimum Quantity is '+this.state.pro_deal_details.best_price_min_qty+'');
			flag =1;
		}
		if(state==='' && !namePattern.test(state) && state.length < 2)
	    {
	      	$('#req_state_err').text('* Enter state');
	      	flag= 1;
	    }
	    if(state !=='' && state.length < 2 && !namePattern.test(state))
	    {
	    	$('#req_state_err').text('* Enter valid state');
	    	flag =1;
	    }
	    {/*if(city==='' && !namePattern.test(city))
	    {
	      	$('#req_city_err').text('* enter city');
	      	flag= 1;
	    }
	    if(city !=='' && city.length < 3)
	    {
	    	$('#req_city_err').text('* enter city');
	    	flag = 1;
	    }
	    if(doorno==='' && doorno.length <= 1)
	    {
	    	$('#req_doorno_err').text('* enter address');
	      	flag= 1;
	    }
	    if(doorno!=='' && doorno.length <= 1)
	    {
	    	$('#req_doorno_err').text('* enter address');
	      	flag= 1;
	    }*/}
		if(pincode==='' && pincode.length < 6)
	    {
	    	$('#req_pincode_err').text('* Enter valid pincode');
	    	flag= 1;
	    }
		if(pincode !=='' && pincode.length < 6)
	    {
	    	$('#req_pincode_err').text('* Enter valid pincode');
	    	flag= 1;
	    }
	    // if(quantity !=='' && quantity < parseInt(this.state.min_qty1,10))
	    // {
	    // 	$('#req_quantity_err').text('* Minimum quantity is '+this.state.min_qty1);
	    // 	flag =1;
	    // }
	    // if(quantity > parseInt(this.state.max_qty1,10))
	    // {
	    // 	$('#req_quantity_err').text('* Maximum quantity is '+this.state.max_qty1);
	    // 	flag =1;
	    // }
		if(flag===0)
	    {
	    	this.setState({
	    		reqbestPrice:false,
	    		// disable_button:false,
	    	});
	    	if(localStorage.source)
			{
				var source=localStorage.getItem('source');
			}
			else
			{
				source='';
			}
			if(localStorage.campaign)
			{
				var campaign=localStorage.getItem('campaign');
			}
			else
			{
				campaign='';
			}
			if(localStorage.url_id)
			{
				var url_id=localStorage.getItem('url_id');
			}
			else
			{
				url_id='';
			}
	    	var data1={from:'desktop_web',id:uid,token:localStorage.token,did:this.props.params.Did,dtype:'1',req_qty:this.state.req_quantity,state:this.state.req_state,city:this.state.req_city,address:this.state.req_doorno,pincode:this.state.req_pincode,source:source,campaign:campaign,url_id:url_id}
	    	var data2=JSON.stringify(data1);
	    	$.ajax({
	    		method:'POST',
	    		dataType:'json',
	    		data:{req:data2},
	    		url:baseUrl+'saveBestpriceLead',
	    		success:function(data)
	    		{
	    			if(data.status==='success')
	    			{
	    				this.setState({
	    					reqbestPrice:false,
	    					req_confirm_modal:true,
	    					req_confirm_message:data.message,
	    				});
	    			}
	    		}.bind(this),
	    		error:function(err)
	    		{
	    			
	    		}
	    	});
	    }
	}
	req_quantityChange(event)
	{
		var x=event.target.value;
		var invalidChars = /[^0-9]/gi;
	    if(invalidChars.test(event.target.value))
	    {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        	req_quantity: x,
	        });
	    }
	}
	req_stateChange(event)
	{
		var x=event.target.value;
		var namePattern = /^[a-z A-Z]+$/;
	    if(!namePattern.test(event.target.value) && x !== '')
	    {
	        x=event.target.value.replace(namePattern,"");
	    }
	   	else
	    {
	    	this.setState({
	    	   	req_state: event.target.value,
	    	});	
	    }
	}
	req_cityChange(event)
	{
		var x=event.target.value;
		var namePattern = /^[a-z A-Z]+$/;
	    if(!namePattern.test(event.target.value) && x !== '')
	    {
	        x = event.target.value.replace(namePattern,"");
	    }
	   	else
	    {
	    	this.setState({
	    	   	req_city: event.target.value,
	    	});	
	    }
	}
	req_doornoChange(event)
	{
		this.setState({
			req_doorno:event.target.value,
		});
	}
	checkBestPriceOnload()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('checkbestprice','1');
			browserHistory.push('/web/login');
		}
		else
		{
			if(localStorage.source)
			{
				var source=localStorage.getItem('source');
			}
			else
			{
				source='';
			}
			if(localStorage.campaign)
			{
				var campaign=localStorage.getItem('campaign');
			}
			else
			{
				campaign='';
			}
			if(localStorage.url_id)
			{
				var url_id=localStorage.getItem('url_id');
			}
			else
			{
				url_id='';
			}
			var data1={from:'desktop_web',did:this.props.params.Did,id:uid,dtype:1,source:source,campaign:campaign,url_id:url_id};
		    var data2=JSON.stringify(data1);
		    $.ajax({
		    	method:'POST',
		    	dataType:'json',
		    	url:baseUrl+'checkBestPriceLead',
		    	data:{req:data2},
		    	success:function(data)
		    	{
		    		if(data.status==='success' && data.proceed===1)
		    		{
		    			this.setState({
		    				reqbestPrice:true,
		    			});
		    			localStorage.removeItem('checkbestprice');
		    		}
		    		else if(data.status==='success' && data.proceed === 0)
		    		{
		    			this.setState({
		    				req_confirm_modal:true,
		    				req_confirm_message:data.msg,
		    			});
		    			localStorage.removeItem('checkbestprice');
		    		}
		    		if(data.status==='error' && data.message==='Token mismatch')
					{
						this.props.tokenCheck();
					}
				}.bind(this),
		    	error:function(err)
		    	{
		    	}
		    });
		}
	}
	checkBestPrice()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('checkbestprice','1');
			browserHistory.push('/web/login');
		}
		else
		{
			if(localStorage.source)
			{
				var source=localStorage.getItem('source');
			}
			else
			{
				source='';
			}
			if(localStorage.campaign)
			{
				var campaign=localStorage.getItem('campaign');
			}
			else
			{
				campaign='';
			}
			if(localStorage.url_id)
			{
				var url_id=localStorage.getItem('url_id');
			}
			else
			{
				url_id='';
			}
			var data1={from:'desktop_web',did:this.props.params.Did,id:uid,dtype:1,source:source,campaign:campaign,url_id:url_id};
		    var data2=JSON.stringify(data1);
		    $.ajax({
		    	method:'POST',
		    	dataType:'json',
		    	url:baseUrl+'checkBestPriceLead',
		    	data:{req:data2},
		    	success:function(data)
		    	{
		    		if(data.status==='success' && data.proceed===1)
		    		{
		    			this.setState({
		    				reqbestPrice:true,
		    			});
		    			localStorage.removeItem('checkbestprice');
		    		}
		    		else if(data.status==='success' && data.proceed === 0)
		    		{
		    			this.setState({
		    				req_confirm_modal:true,
		    				req_confirm_message:data.msg,
		    			});
		    			localStorage.removeItem('checkbestprice');
		    		}
		    		if(data.status==='error' && data.message==='Token mismatch')
					{
						this.props.tokenCheck();
					}
				}.bind(this),
		    	error:function(err)
		    	{
		    	}
		    });
		}
	}
	req_pincodeChange(event)
	{
		var x=event.target.value;
		var invalidChars = /[^0-9]/gi;
	    if(invalidChars.test(event.target.value))
	    {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        	req_pincode: x,
	        });
	    }
	}
	getswipeDescription(pid,cid)
	{
		this.props.getProductDesc(pid,cid);
		this.setState({
		    		swipe_attr_status:cid,
		    		});		
 			// this.setState({
 			// 	swipe_description_status:pid,
 			// });
 			// var func='';
	}
	ShareFunc(evnt)
	{
		var data1={from: 'desktop_web',type:1,did:evnt};
    	var data2=JSON.stringify(data1); 
		$.ajax({
	          method: 'POST',
	          url: baseUrl+'createTinyurl',
	          dataType:'json',
	          data: {req:data2},
	          success: function(data)
	          {
	            this.setState({
	              shareUrl: data.tinyurl,
	            });
	       	  }.bind(this),
	          error: function(err)
	          {
	          }
        });
   		this.setState({ open: !this.state.open }) ;
   		setTimeout(() => {this.setState({open: false}); }, 10000);
   	}
	decrementMinQty()
  	{
  		var minquantity='';
  		var removedquantity='';
		var total ='';
		setTimeout(function(){ 
			$('.plus_btn img').attr('src',require('./../../../assets/images/plus.png'));
			if(parseInt(this.refs.input_minqty.value)-1  <=  parseInt(this.state.min_qty1)){
				$('.minus_btn img').attr('src',require('./../../../assets/images/minus_orange_fade.png'));
			}
		 }.bind(this), 100); 					
  		if(this.state.unit_name==="")
  		{
  			minquantity=parseInt(this.state.min_qty,10);
  		}
  		else if(parseInt(this.state.min_qty,10) <= parseInt(this.state.min_qty1,10))
		{
			minquantity=parseInt(this.state.min_qty1,10);
			removedquantity=parseInt(500 / minquantity, 10);
			total=parseInt(minquantity,10);
		}
		else if(this.state.unit_name==="kg" && this.state.type==="Feed")
  		{
  			// minquantity=parseInt(this.state.min_qty,10);
  			// removedquantity=parseInt(500 / this.state.qty, 10);
  			// total = parseInt(minquantity - removedquantity,10)
  			if(this.state.min_qty==='' || this.state.min_qty==='NaN')
  			{
  				minquantity=parseInt(this.state.min_qty1,10);
	  			removedquantity=parseInt(500 / this.state.qty, 10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}
	  		}
  			else
  			{
  				minquantity=parseInt(this.state.min_qty,10);
	  			removedquantity=parseInt(500 / this.state.qty, 10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}	
  			}
  		}
  		else if(this.state.unit_name==="kg" && this.state.type ==="Health Care")
  		{
  			// minquantity=parseInt(this.state.min_qty,10);
  			// removedquantity=parseInt(1,10);
  			// total=parseInt(minquantity - removedquantity,10);
  			if(this.state.min_qty==='' || this.state.min_qty==='NaN')
  			{
  				minquantity=parseInt(this.state.min_qty1,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}
	  		}
  			else
  			{
  				minquantity=parseInt(this.state.min_qty,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}	
  			}
  		}
  		else if(this.state.unit_name==="kg" && this.state.type ==="Hatchery Health Care")
  		{
  			// minquantity=parseInt(this.state.min_qty,10);
  			// removedquantity=parseInt(1,10);
  			// total=parseInt(minquantity - removedquantity,10);
  			if(this.state.min_qty==='' || this.state.min_qty==='NaN')
  			{
  				minquantity=parseInt(this.state.min_qty1,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}
	  		}
  			else
  			{
  				minquantity=parseInt(this.state.min_qty,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}	
  			}
  		}
  		else if(this.state.unit_name==="gm" && this.state.type==="Feed")
  		{
  			// minquantity=parseInt(this.state.min_qty,10);
  			// removedquantity=parseInt(500 * 1000 / this.state.qty,10);
  			// total=parseInt(minquantity - removedquantity,10);
  			if(this.state.min_qty==='' || this.state.min_qty==='NaN')
  			{
  				minquantity=parseInt(this.state.min_qty1,10);
	  			removedquantity=parseInt(500 * 1000 / this.state.qty,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}
	  		}
  			else
  			{
  				minquantity=parseInt(this.state.min_qty,10);
	  			removedquantity=parseInt(500 * 1000 / this.state.qty,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}	
  			}
  		}
  		else if(this.state.unit_name ==="gm" && this.state.type==="Health Care")
  		{
  			// minquantity=parseInt(this.state.min_qty,10);
  			// removedquantity=parseInt(1,10);
  			// total=parseInt(minquantity - removedquantity,10);
  			if(this.state.min_qty==='' || this.state.min_qty==='NaN')
  			{
  				minquantity=parseInt(this.state.min_qty1,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}
	  		}
  			else
  			{
  				minquantity=parseInt(this.state.min_qty,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}	
  			}
		}
		else if(this.state.unit_name ==="gm" && this.state.type==="Hatchery Health Care")
  		{
  			// minquantity=parseInt(this.state.min_qty,10);
  			// removedquantity=parseInt(1,10);
  			// total=parseInt(minquantity - removedquantity,10);
  			if(this.state.min_qty==='' || this.state.min_qty==='NaN')
  			{
  				minquantity=parseInt(this.state.min_qty1,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}
	  		}
  			else
  			{
  				minquantity=parseInt(this.state.min_qty,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}	
  			}
		}
		
		else if(this.state.unit_name ==="ltr" && this.state.type==="Feed")
		{
			// minquantity=parseInt(this.state.min_qty,10);
			// removedquantity=parseInt(500 / this.state.qty,10);
			// total=parseInt(minquantity - removedquantity,10);
			if(this.state.min_qty==='' || this.state.min_qty==='NaN')
  			{
  				minquantity=parseInt(this.state.min_qty1,10);
	  			removedquantity=parseInt(500 / this.state.qty,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}
	  		}
  			else
  			{
  				minquantity=parseInt(this.state.min_qty,10);
	  			removedquantity=parseInt(500 / this.state.qty,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}	
  			}
		}
		else if(this.state.unit_name ==="ltr" && this.state.type==="Health Care")
		{
			// minquantity=parseInt(this.state.min_qty,10);
  			// removedquantity=parseInt(1,10);
  			// total=parseInt(minquantity - removedquantity,10);
  			if(this.state.min_qty==='' || this.state.min_qty==='NaN')
  			{
  				minquantity=parseInt(this.state.min_qty1,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}
	  		}
  			else
  			{
  				minquantity=parseInt(this.state.min_qty,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}	
  			}
		}
		else if(this.state.unit_name ==="ltr" && this.state.type==="Hatchery Health Care")
		{
			// minquantity=parseInt(this.state.min_qty,10);
  			// removedquantity=parseInt(1,10);
  			// total=parseInt(minquantity-removedquantity,10);
  			if(this.state.min_qty==='' || this.state.min_qty==='NaN')
  			{
  				minquantity=parseInt(this.state.min_qty1,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}
	  		}
  			else
  			{
  				minquantity=parseInt(this.state.min_qty,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}	
  			}
		}
		else if(this.state.unit_name==="nos")
		{
			// minquantity=parseInt(this.state.min_qty,10);
  			// removedquantity=parseInt(1,10);
  			// total=parseInt(minquantity-removedquantity,10);
  			if(this.state.min_qty==='' || this.state.min_qty==='NaN')
  			{
  				minquantity=parseInt(this.state.min_qty1,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}
	  		}
  			else
  			{
  				minquantity=parseInt(this.state.min_qty,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}	
  			}
		}
		else
		{
			// minquantity=parseInt(this.state.min_qty,10);
		  	// removedquantity=parseInt(1,10);
		  	// total=parseInt(minquantity-removedquantity,10);
  			if(this.state.min_qty==='' || this.state.min_qty==='NaN')
  			{
  				minquantity=parseInt(this.state.min_qty1,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}
	  		}
  			else
  			{
  				minquantity=parseInt(this.state.min_qty,10);
	  			removedquantity=parseInt(1,10);
	  			if(parseInt(minquantity - removedquantity,10) < parseInt(this.state.min_qty1,10) || parseInt(minquantity - removedquantity,10)==='NaN')
	  			{
	  				this.setState({
	  					qty_err_status:true,
	  					qty_err_msg:'* Minimum Quantity is '+this.state.min_qty1,
	  				})
	  				total=this.state.min_qty1;
	  			}
	  			else
	  			{
	  				total = parseInt(minquantity - removedquantity,10)		
	  			}	
  			}
		}
		
		if(this.state.is_cart===1 && this.state.unit_name!=="nos")
		{
			this.setState({
	 			min_qty :  parseInt(total,10),
	 			tons: total * this.state.qty / 1000,
	 			addtocart_msg:'Update Cart',
	 			// addtocart_status:false,
 			});	
		}
		else if(this.state.is_cart===0 && this.state.unit_name==="nos")
		{
			this.setState({
				min_qty :  parseInt(total,10),
	 			// tons: total * this.state.qty / 1000,
	 			addtocart_msg:'Add to Cart',
			});
		}
		else if(this.state.is_cart===0 && this.state.unit_name==="kg")
		{
			this.setState({
	 			min_qty :  parseInt(total,10),
	 			tons: total * this.state.qty / 1000,
	 			addtocart_msg:'Add to Cart',
	 			// addtocart_status:false,
 			});	
		}
		else if(this.state.is_cart===0 && this.state.unit_name==="gm")
		{
			this.setState({
	 			min_qty :  parseInt(total,10),
	 			tons: (total * this.state.qty /1000) / 1000,
	 			addtocart_msg:'Add to Cart',
	 			// addtocart_status:false,
 			});
		}
		else if(this.state.is_cart===1 && this.state.unit_name==="nos")
		{
			this.setState({
	 			min_qty :  parseInt(total,10),
	 			addtocart_msg:'Update Cart',
	 			// addtocart_status:false,
 			});	
		}
		else
		{
			if(this.state.is_cart===0)
			{
				this.setState({
					min_qty :  parseInt(total,10),
		 			// tons: total * this.state.qty / 1000,
		 			addtocart_msg:'Add to Cart',
				});
			}
			if(this.state.is_cart===1)
			{
				this.setState({
		 			min_qty :  parseInt(total,10),
		 			addtocart_msg:'Update Cart',
		 		});	
			}
		}
	}
  	updateMinQty(event)
 	{
 		var x=event.target.value;
		var invalidChars = /[^0-9]/gi;
	    if(invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        	min_qty: x,
	        	tons: x * this.state.qty / 1000,
	        });
	    }
 		if(x > parseInt(this.state.max_qty1,10))
 		{
 			this.setState({
 				min_qty:this.state.max_qty1,
 				tons:this.state.max_qty1 * this.state.qty / 1000,
 			});
 		}
 	}
 	incrementMinQty()
  	{
		setTimeout(function(){ 
	  		$('.minus_btn img').attr('src',require('./../../../assets/images/minus_orange.png'));
			if(parseInt(this.refs.input_minqty.value)  >=  parseInt(this.state.max_qty1)){
				$('.plus_btn img').attr('src',require('./../../../assets/images/plus_fade.png'));
			}  		  		
		 }.bind(this), 100); 		

  		this.setState({
  			qty_err_status:false,
  		});
  		if(this.state.unit_name==="kg")
  		{
	  			var add='';
	  			var tons='';
	  			if(this.state.type==="Feed" && this.refs.input_minqty.value!=='')
	  			{
	  			  add=parseInt(this.state.min_qty,10) + parseInt(500 / this.state.qty,10);
	  			  tons=add * this.state.qty / 1000;
	  			}
	  			else if(this.state.type==="Feed" && this.refs.input_minqty.value==='' )
	  			{
	  				add=parseInt(this.state.min_qty1,10) + parseInt(500 / this.state.qty,10);
	  				tons=add * this.state.qty / 1000;
	  			}
	  			if((this.state.type==="Health Care" || this.state.type==="Hatchery Health Care") && this.refs.input_minqty.value!=='')
	  			{
	  				add=parseInt(this.state.min_qty,10) + 1;
	  				tons=add * this.state.qty / 1000;
	  			}
	  			else if((this.state.type==="Health Care" || this.state.type==="Hatchery Health Care") && this.refs.input_minqty.value==='' )
	  			{
	  				add=parseInt(this.state.min_qty1,10) + parseInt(500 / this.state.qty,10);
	  				tons=add * this.state.qty / 1000;
	  			}

	  			if(add > this.state.max_qty1)
	  			{
	  				// alert("Maximum limit is "+this.state.max_qty1)
	  				this.setState({
	  					min_qty: this.state.max_qty1,
	  					tons: this.state.max_qty1 * this.state.qty / 1000,
	  					qty_err_status:true,
						qty_err_msg:"* Maximum Quantity is "+this.state.max_qty1,
	  				});
	  			}
	  			else
	  			{
	  				if(this.state.is_cart===1)
	  				{
	  					this.setState({
		  			 		min_qty: add,
		  			 		tons:tons,
		  			 		addtocart_msg:'Update Cart',
		  				});	
	  				}
	  				else
	  				{
	  					this.setState({
		  			 		min_qty: add,
		  			 		tons:tons,
		  			 		addtocart_msg:'Add to Cart',
		  				});	
	  				}
	  				
	  			}
  			}

			//  GRAMS INCREMENT 
	  		else if(this.state.unit_name==="gm")
	  		{
		  			
		  			if(this.state.type==="Feed" && this.refs.input_minqty.value!=='')
		  			{
		  				add=parseInt(this.state.min_qty,10) + parseInt(500 * 1000 / this.state.qty,10);
		  				tons=(add * this.state.qty /1000) / 1000;
		  			}
		  			else if(this.state.type==="Feed" && this.refs.input_minqty.value==='')
		  			{
		  				add=parseInt(this.state.min_qty1,10) + parseInt(500 * 1000 / this.state.qty,10);
		  				tons=(add * this.state.qty /1000) / 1000;
		  			}

		  			if((this.state.type==="Health Care" || this.state.type==="Hatchery Health Care") && this.refs.input_minqty.value!=='')
		  			{
		  				add=parseInt(this.state.min_qty,10) + parseInt(1,10);	
		  				tons=(add * this.state.qty /1000) / 1000;
		  			}
		  			else if((this.state.type==="Health Care" || this.state.type==="Hatchery Health Care") && this.refs.input_minqty.value==='')
		  			{
		  				add=parseInt(this.state.min_qty1,10) + parseInt(1,10);	
		  				tons=(add * this.state.qty /1000) / 1000;
		  			}

		  			//  adding if not greater thn limit.
		  			if(add > this.state.max_qty1)
			  		{
			  				// alert("Maximum limit is "+this.state.max_qty1)
			  				
			  				this.setState({
			  					min_qty: this.state.max_qty1,
			  					qty_err_status:true,
								qty_err_msg:"* Maximum Quantity is "+this.state.max_qty1,
			  				});
			  		}
			  		else
			  		{
			  				if(this.state.is_cart===1)
			  				{
			  					this.setState({
				  			 		min_qty: add,
				  			 		tons: tons,
				  			 		addtocart_msg:'Update Cart',
				  				});	
			  				}
			  				else
			  				{
			  					this.setState({
				  			 		min_qty: add,
				  			 		tons: tons,
				  			 		addtocart_msg:'Add to Cart',
				  				});	
			  				}
			  				
			  		}
	  		}
	  		// LTR's
	  		else if(this.state.unit_name==="ltr")
	  		{
		  			
		  			if(this.state.type==="Feed" && this.refs.input_minqty.value!=='')
		  			{
		  				add=parseInt(this.state.min_qty,10) + parseInt(500 / this.state.qty,10);
		  			}
		  			else if(this.state.type==="Feed" && this.refs.input_minqty.value==='')
		  			{
		  				add=parseInt(this.state.min_qty1,10) + parseInt(500 / this.state.qty,10);
		  			}

		  			if((this.state.type==="Health Care" || this.state.type==="Hatchery Health Care") && this.refs.input_minqty.value!=='')
		  			{
		  				add=parseInt(this.state.min_qty,10) + parseInt(1,10);	
		  			}
		  			else if((this.state.type==="Health Care" || this.state.type==="Hatchery Health Care") && this.refs.input_minqty.value==='')
		  			{
		  				add=parseInt(this.state.min_qty1,10) + parseInt(1,10);	
		  			}

		  			if(add > this.state.max_qty1)
			  		{
			  				// alert("Maximum limit is "+this.state.max_qty1)
			  				this.setState({
			  					min_qty: this.state.max_qty1,
			  					qty_err_status:true,
								qty_err_msg:"* Maximum Quantity is "+this.state.max_qty1,
			  				});
			  		}
			  		else
			  		{
			  				if(this.state.is_cart ===1)
			  				{
			  					this.setState({
				  			 		min_qty: add,
				  			 		addtocart_msg:'Update Cart',
				  				});	
			  				}
			  				else
			  				{
			  					this.setState({
				  			 		min_qty: add,
				  			 		addtocart_msg:'Add to Cart',
				  				});	
			  				}
			  				
			  		}
  			}

	  	else if(this.state.unit_name==="nos")
	  	{
			 if(this.refs.input_minqty.value!=='')
			 {
			 	add=parseInt(this.state.min_qty,10) + 1;	
			 }
			 else
			 {
			 	add=parseInt(this.state.min_qty1,10);
			 }

			 if(add > this.state.max_qty1)
			 {
			 	
			 	this.setState({
					min_qty: this.state.max_qty1,
					qty_err_status:true,
					qty_err_msg:"* Maximum Quantity is "+this.state.max_qty1,
			  	});
			 }
			 else
			 {
			 	if(this.state.is_cart===1)
			  	{
				  	this.setState({
				  		min_qty:add,
				  		addtocart_msg:'Update Cart',
				  	});
				}
				else
				{
				 	this.setState({
				  		min_qty:add,
				  		addtocart_msg:'Add to Cart',
				 	});
				}
		     }
		}

		else
	  	{
			if(this.refs.input_minqty.value!=='')
			{
			 	add=parseInt(this.state.min_qty,10) + 1;	
			}
			else
			{
				add=parseInt(this.state.min_qty1,10);
			}

			if(add > this.state.max_qty1)
			{
			 	
			 	this.setState({
					min_qty: this.state.max_qty1,
					qty_err_status:true,
					qty_err_msg:"* Maximum Quantity is "+this.state.max_qty1,
			  	});
			}
			else
			{
			 	if(this.state.is_cart===1)
			  	{
				  	this.setState({
				  		min_qty:add,
				  		addtocart_msg:'Update Cart',
				  	});
				}
				else
				{
				 	this.setState({
				  		min_qty:add,
				  		addtocart_msg:'Add to Cart',
				 	});
				}
		    }
		}
	}
	addToCartOnload()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		if(this.state.addtocart_msg ==="Go to Cart")
		{
			browserHistory.push('/web/mycart');
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			if(this.props.params.Bname)
			{
				localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);		
			}
			else
			{
				localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);
			}
			localStorage.setItem('addtocart','1');
			browserHistory.push('/web/login');
		}
		else
		{
			this.setState({
				rotateClass:true,
			})
			var quantity='';
			if(localStorage.addtocart_qty)
			{
				quantity=localStorage.getItem('addtocart_qty');
			}
			if( parseInt(quantity,10) < parseInt(this.state.min_qty1,10) || quantity==="NaN")
			{
				this.setState({
					qty_err_status: true,
					qty_err_msg: "* Minimum Quantity is "+this.state.min_qty1,
				});
				// quantity=this.state.min_qty1;
			}
			else
			{
				// quantity=this.refs.input_minqty.value;
				if(localStorage.addtocart_qty)
				{
					quantity=localStorage.getItem('addtocart_qty');
				}
				else
				{
					quantity=this.state.min_qty;
				}
				var data1={from: 'desktop_web',id:uid,token:localStorage.getItem('token'),deal_id:this.state.dealid,deal_type:1,quantity:quantity,pl_size:0,salinity:0,pickup_date:0}
				var data2=JSON.stringify(data1);
				$.ajax({
					method:'post',
					dataType:'json',
					url: baseUrl+'addToCart',
					data:{req:data2},
					success:function(data)
					{
						if(data.status==="success" && data.message==="Added to cart")
						{
							this.setState({
								addtocart_msg:'Go to Cart',
								is_cart:data.cart_flag,
							});
							// this.getCartCount();
							localStorage.removeItem('addtocart');
							localStorage.removeItem('addtocart_qty');
						}
						if(data.status==="success" && data.message==="Cart Updated")
						{
							this.setState({
								addtocart_msg:'Go to Cart',
								is_cart:data.cart_flag,
							});
							localStorage.removeItem('addtocart');
							localStorage.removeItem('addtocart_qty');
						}
						if(data.status==="error" && data.cart_flag===0)
						{
							this.setState({
								clearcart_status: true,
							});
							localStorage.removeItem('addtocart');
							localStorage.removeItem('addtocart_qty');
						}
						if(data.status==="error" && data.message==="Product already added to the cart" && data.cart_flag ===1)
						{
							this.setState({
								cart_added_status: true,
								addtocart_msg:'Go to Cart',
								// addtocart_status:true,
								is_cart:data.cart_flag,
							});
							localStorage.removeItem('addtocart');
							localStorage.removeItem('addtocart_qty');
						}
						this.getCartCount();
					   if(data.status==='error' && data.message==='Token mismatch')
					   {
					   	  this.props.tokenCheck();
					   }
					}.bind(this),
					error:function(err)
					{
					}
				});
			}
		}
	}
  	placeOrderModal()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		if(this.state.addtocart_msg ==="Go to Cart")
		{
			browserHistory.push('/web/mycart');
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			var quantity='';
			if(this.refs.input_minqty.value < parseInt(this.state.min_qty1,10) || this.refs.input_minqty.value==="NaN")
			{
				this.setState({
					qty_err_status: true,
					qty_err_msg: "* Minimum Quantity is "+this.state.min_qty1,
				});
				quantity=this.state.min_qty1;
			}
			else if(this.refs.input_minqty.value > parseInt(this.state.max_qty1,10))
			{
				this.setState({
					qty_err_status:true,
					qty_err_msg:"* Maximum Quantity is "+this.state.max_qty1,
				})
				quantity=this.state.max_qty1;
			}
			else
			{
				if(this.props.params.Bname)
				{
					localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);	
				}
				else
				{
					localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);					
				}
				localStorage.setItem('w_r_p_dt','/web/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.Did);
				localStorage.setItem('addtocart','1');
				localStorage.setItem('addtocart_qty',this.state.min_qty);
				browserHistory.push('/web/login');
			}
		}
		else
		{
			if(this.state.addtocart_msg ==="Add to Cart" || this.state.addtocart_msg ==="Update Cart")
			{
				this.setState({
					rotateClass:true,
				});
				quantity='';
				if(this.refs.input_minqty.value < parseInt(this.state.min_qty1,10) || this.refs.input_minqty.value==="NaN")
				{
					this.setState({
						qty_err_status: true,
						qty_err_msg: "* Minimum Quantity is "+this.state.min_qty1,
					});
					quantity=this.state.min_qty1;
				}
				else
				{
					quantity=this.refs.input_minqty.value;
					if(localStorage.source)
					{
						var source=localStorage.getItem('source');
					}
					else
					{
						source='';
					}
					if(localStorage.campaign)
					{
						var campaign=localStorage.getItem('campaign');
					}
					else
					{
						campaign='';
					}
					if(localStorage.url_id)
					{
						var url_id=localStorage.getItem('url_id');
					}
					else
					{
						url_id='';
					}
					var data1={from: 'desktop_web',id:uid,token:localStorage.getItem('token'),deal_id:this.state.deal_did,deal_type:1,quantity:quantity,pl_size:0,salinity:0,pickup_date:0,source:source,campaign:campaign,url_id:url_id}
					var data2=JSON.stringify(data1);
					$.ajax({
						method:'post',
						dataType:'json',
						url: baseUrl+'addToCart',
						data:{req:data2},
						success:function(data)
						{
							if(data.status==="success" && data.message==="Added to cart")
							{
								this.setState({
									addtocart_msg:'Go to Cart',
									is_cart:data.cart_flag,
									qty_err_status:false,
								});
								// this.getCartCount();
								localStorage.removeItem('addtocart');
								localStorage.removeItem('addtocart_qty');
							}
							if(data.status==="success" && data.message==="Cart Updated")
							{
								this.setState({
									addtocart_msg:'Go to Cart',
									is_cart:data.cart_flag,
									qty_err_status:false,
								});
								localStorage.removeItem('addtocart');
								localStorage.removeItem('addtocart_qty');
							}
							if(data.status==="error" && data.cart_flag===0)
							{
								this.setState({
									clearcart_status: true,
								});
								localStorage.removeItem('addtocart');
								localStorage.removeItem('addtocart_qty');
							}
							if(data.status==="error" && data.message==="Product already added to the cart" && data.cart_flag ===1)
							{
								this.setState({
									cart_added_status: true,
									addtocart_msg:'Go to Cart',
									qty_err_status:false,
									// addtocart_status:true,
									is_cart:data.cart_flag,
								});
								localStorage.removeItem('addtocart');
								localStorage.removeItem('addtocart_qty');
							}
							this.getCartCount();
						}.bind(this),
						error:function(err){
						}
					});
				}
			}
		}
	}
	// **********************
	getAdAssistModal()
	{
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('adassist_status','1');
			browserHistory.push('/web/login');
		}
		else
		{
			if(localStorage.user_id)
			{
				var uid=localStorage.getItem('user_id');
			}
			else
			{
				uid=0;
			}
			if(localStorage.source)
			{
				var source=localStorage.getItem('source');
			}
			else
			{
				source='';
			}
			if(localStorage.campaign)
			{
				var campaign=localStorage.getItem('campaign');
			}
			else
			{
				campaign='';
			}
			if(localStorage.url_id)
			{
				var url_id=localStorage.getItem('url_id');
			}
			else
			{
				url_id='';
			}
			var data1={from:'desktop_web',id:uid,pid:this.props.params.Pid,token:localStorage.getItem('token'),source:source,campaign:campaign,url_id:url_id}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				data:{req:data2},
				url:baseUrl+'checkaskExpert',
				success:function(data)
				{
					if(data.status==='success' && data.proceed===1)
					{
						this.setState({
							ad_assist_modal:!this.state.ad_assist_modal,
							assist_data:data,
							queries:data.queries
						});
						localStorage.removeItem('adassist_status');
					}
					if(data.status==='success' && data.proceed===0)
					{
						this.setState({
							ad_asst_confirm_modal:true,
							ad_asst_confirm_message:data.msg,
						});
						localStorage.removeItem('adassist_status');
					}
				}.bind(this),
				error:function(err)
				{

				}
			})
		}
	}
	submitAdAssistData(event)
	{
		event.preventDefault();
		var error_flag=false;
		var q_id=$('#ad-sel-question').val();
		if(q_id == 1){
			$('#ad-sel-question').css("color", "red");
			$('#ad-sel-question option').css("color", "#666");
			error_flag=true;
		}else{
			$('#ad-sel-question').css("color", "#666");
			$('#ad-sel-question option').css("color", "#666");
			error_flag=false;			
		}
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		var ad_time=this.state.ad_asst_time ? this.state.ad_asst_time : '0';
		if(ad_time == '0'){
			error_flag =true;
			this.setState({
				time_err_status:true,
				time_err_msg:'* Required',
			})						
		}
		if(!error_flag)
		{
			var data1={from:'desktop_web',id:uid,token:localStorage.token,pid:this.props.params.Pid,time:ad_time,desc:'',source:source,campaign:campaign,url_id:url_id,selectedQue:q_id};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				data:{req:data2},
				url:baseUrl+'askExpert',
				success:function(data)
				{
					if(data.status==='success')
					{
						this.setState({
							ad_assist_modal:false,
							ad_asst_confirm_message:data.message,
							ad_asst_confirm_modal:true,
						});

					}
					else
					{
						this.setState({
							ad_assist_modal:false,
							// ad_asst_confirm_message:data.message,
						});
					}
				}.bind(this),
				error:function(err)
				{

				}
			})
		}		
	}
	setAdTime(val)
	{
		this.setState({
			ad_asst_time:val,
		})
	}
	likeBrandOnload()
	{
		if(localStorage.web_likebrand_status)
		{
			var status=localStorage.getItem('web_likebrand_status');
		}
		else
		{
			status='';
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('web_likebrand','1');
			localStorage.setItem('web_likebrand_qty',status);
			browserHistory.push('/web/login');
		}
		else
		{	
			if(localStorage.user_id)
			{
				var uid=localStorage.getItem('user_id');
			}
			else
			{
				uid=0;
			}
			var data1={from:'desktop_web',id:uid,token:localStorage.token,brand_id:localStorage.getItem('web_likebrand_bid'),status:status};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				url:baseUrl+'like_brand',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==='success')
					{
						this.setState({
							brand_like_status:data.like_status,
							brand_likes_count:data.brand_likes_count,
						});
						localStorage.removeItem('web_likebrand');
						localStorage.removeItem('web_likebrand_status');
						localStorage.removeItem('web_likebrand_bid');
					}
					if(data.like_status===1)
					{
						this.setState({
							brand_like_status:'1',
						});
						localStorage.removeItem('web_likebrand');
						localStorage.removeItem('web_likebrand_status');
						localStorage.removeItem('web_likebrand_bid');
					}
					else
					{
						this.setState({
							brand_like_status:'0',
						});
						localStorage.removeItem('web_likebrand');
						localStorage.removeItem('web_likebrand_status');
						localStorage.removeItem('web_likebrand_bid');
					}
				}.bind(this),
				error:function(err)
				{
				}
			});
		}
	}
	likeBrand(status)
	{
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('web_likebrand','0');
			localStorage.setItem('web_likebrand_status',status);
			localStorage.setItem('web_likebrand_bid',this.state.bid);
			browserHistory.push('/web/login');
		}
		else
		{	
			if(localStorage.user_id)
			{
				var uid=localStorage.getItem('user_id');
			}
			else
			{
				uid=0;
			}
			var data1={from:'desktop_web',id:uid,token:localStorage.token,brand_id:this.state.offer.bid,status:status};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				url:baseUrl+'like_brand',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==='success')
					{
						this.setState({
							brand_like_status:data.like_status,
							brand_likes_count:data.brand_likes_count,
						});
						localStorage.removeItem('web_likebrand');
						localStorage.removeItem('web_likebrand_status');
						localStorage.removeItem('web_likebrand_bid');
					}
					if(data.like_status===1)
					{
						this.setState({
							brand_like_status:'1',
						});
						localStorage.removeItem('web_likebrand');
						localStorage.removeItem('web_likebrand_status');
						localStorage.removeItem('web_likebrand_bid');
					}
					else
					{
						this.setState({
							brand_like_status:'0',
						});
						localStorage.removeItem('web_likebrand');
						localStorage.removeItem('web_likebrand_status');
						localStorage.removeItem('web_likebrand_bid');
					}
				}.bind(this),
				error:function(err)
				{
				}
			});
		}
	}
	getSimilarBrandDeals()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		this.setState({
			similar_brand_deals_status: true,
			similar_category_deals_status:false,
			similar_stage_deals_status:false,
		});
		if(this.state.similar_brand_deals_status)
		{
			var data1={from:'desktop_web',tid:this.state.bid,type:'brand',dtype:this.state.pro_details.dtype,uid:uid,page:1,bid:'',sort:'',pDetails_viewmore:1,deal_id:this.props.params.Did};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				url:baseUrl+'getProductbycat_brand',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==='success')
					{
						this.setState({
							similar_brand_deals:data.result,
						});
					}
				}.bind(this),
				error:function(err)
				{
				}
			});
		}
	}
	getSimilarCatDeals()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		this.setState({
			similar_category_deals_status: true,
			similar_brand_deals_status:false,
			similar_stage_deals_status:false,
		});
		// if(!this.state.similar_category_deals_status)
		// {
			var data1={from:'desktop_web',tid:this.state.pro_details.category_id,type:'Pcategory',dtype:this.state.pro_details.dtype,uid:uid,page:1,bid:'',sort:'',pDetails_viewmore:1,deal_id:this.props.params.Did};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				url:baseUrl+'getProductbycat_brand',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==='success')
					{
						this.setState({
							similar_category_deals:data.result,
						});
					}
				}.bind(this),
				error:function(err)
				{
				}
			});
		// }
	}
	getSimilarStageDeals()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		this.setState({
			similar_stage_deals_status: true,
			similar_category_deals_status:false,
			similar_brand_deals_status:false,
		});
		// if(!this.state.similar_stage_deals_status)
		// {
			var data1={from:'desktop_web',tid:this.state.pro_details.stage,type:'stage',dtype:this.state.pro_details.dtype,uid:uid,page:1,bid:'',sort:'','pDetails_viewmore':1,deal_id:this.props.params.Did};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				url:baseUrl+'getProductbycat_brand',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==='success')
					{
						this.setState({
							similar_stage_deals:data.result,
						});
					}
				}.bind(this),
				error:function(err)
				{
				}
			});
		// }
	}
  	addtowishlistOnload()
  	{
  		if(!localStorage.user_id && !localStorage.token)
  		{
  			localStorage.setItem('web_addtowishlist','1');
  			browserHistory.push('/web/login');
  		}
  		else
  		{
  			if(localStorage.user_id)
			{
				var uid=localStorage.getItem('user_id');
			}
			else
			{
				uid=0;
			}
			// this.setState({
	 		// 		page_loading:true,
	 		// });
	 		var data1={from:'desktop_web',id:uid,token:localStorage.token,type:1,did:this.props.params.Did};
	 		var data2=JSON.stringify(data1);
	 		$.ajax({
	 			method:'POST',
	 			dataType:'json',
	 			data:{req:data2},
	 			url:baseUrl+'addToWishlist',
	 			success:function(data)
	 			{
	 				if(data.status==='success' && data.message==='Added to wish list')
	 				{
	 					this.setState({
	 						wishLst_flag:1,
	 						page_loading:false,
	 					});
	 				}
	 				else if(data.status==='error' && data.message==='Token mismatch')
	 				{
	 					this.tokenCheck();
	 				}
	 				localStorage.removeItem('web_addtowishlist');
	 			}.bind(this),
	 			error:function(err)
	 			{
	 				this.setState({
	 					page_loading:false,
	 				});
	 			}
	 		});
  		}
  	}
  	addToWishlist()
  	{
  		if(!localStorage.user_id && !localStorage.token)
  		{
  			localStorage.setItem('web_addtowishlist','1');
  			browserHistory.push('/web/login');
  		}
  		else
  		{
  			if(localStorage.user_id)
			{
				var uid=localStorage.getItem('user_id');
			}
			else
			{
				uid=0;
			}
			this.setState({
	 			page_loading:true,
	 		});
	 		var data1={from:'desktop_web',id:uid,token:localStorage.token,type:1,did:this.state.pro_deal_details.id};
	 		var data2=JSON.stringify(data1);
	 		$.ajax({
	 			method:'POST',
	 			dataType:'json',
	 			data:{req:data2},
	 			url:baseUrl+'addToWishlist',
	 			success:function(data)
	 			{
	 				if(data.status==='success' && data.message==='Added to wish list')
	 				{
	 					this.setState({
	 						wishLst_flag:1,
	 						page_loading:false,
	 					});
	 				}
	 				else if(data.status==='error' && data.message==='Token mismatch')
	 				{
	 					this.tokenCheck();
	 				}
	 				localStorage.removeItem('web_addtowishlist');
	 			}.bind(this),
	 			error:function(err)
	 			{
	 				this.setState({
	 					page_loading:false,
	 				});
	 			}
	 		});
  		}
  	}
		  
 	videoplayer(url,id){
		var url = url.split("=").pop();
		window.open("http://www.youtube.com/embed/"+url);
	}
	toggleDisclaimer(){
		    this.setState({visibility:!this.state.visibility});
	}		  	
	 render(){
	   var that=this;	 	
	   var carousel_params = '';

	   var img_array = $.makeArray(this.state.imgs);
	   if(img_array.length > 1){
		   carousel_params = {
			 pagination: {
			   el: '.swiper-pagination',
			   clickable: true,
			   dynamicBullets: false
			 }
		   }
	   }else{
		   carousel_params = {
			   paginationClickable: true,
			   slidesPerView: 1,
			   spaceBetween:0
		   }
	   }
	   var self = this;
	   var product_imgs = img_array.map(function(image, index) {
			   if(image.url){
			   return (<div style={{'maxWidth':'100%'}} className={'slide-id-'+(index)}><div onClick={()=>{self.videoplayer(image.url,index);}} style={{height:'355px'}}><i>&nbsp;</i><table id="wrapper">
					 <tr>
					   <td>
					   	<img itemProp="image" src={baseAssets+'images/product_imgs/'+image.img}/>
					   	<div className="web_play_icon">
					   		<span><img src={baseAssets+'images/play_icon.png'} alt=" "/></span>
					   	</div>	
					   </td>
					 </tr>
				   </table>
				   </div></div>)	      		  
			   }else{
			   return (<div style={{'maxWidth':'100%'}}><img itemProp="image" src={baseAssets+'images/product_imgs/'+image.img} alt=" " height="355px" className={'img-item-'+(index%2 ? 'even':'odd')}/></div>);
			   {/*return (<div className="iframe-container"><div style={{height:'355px'}}><iframe src="https://www.youtube.com/embed/QH2-TGUlwu4" width="560" height="315" frameborder="0"></iframe></div></div>);*/}
			   }

	   });


		$('.min_qty_btn input').unbind("keyup").keyup( function(e){

		    	
		    	if(parseInt($('.min_qty_btn input').val()) < parseInt(that.state.min_qty1)){
					$('.plus_btn img').attr('src',require('./../../../assets/images/plus.png'));
					$('.minus_btn img').attr('src',require('./../../../assets/images/minus_orange.png'));					
		    	}
		    	if( (parseInt($('.min_qty_btn input').val()) < parseInt(that.state.min_qty1)) || isNaN((parseInt($('.min_qty_btn input').val()))) ){
					$('.minus_btn img').attr('src',require('./../../../assets/images/minus_orange_fade.png'));					
		    	}		    	
				if(e.keyCode == 8){
			    	if(parseInt($('.min_qty_btn input').val()) < parseInt(that.state.min_qty1)){
			    		console.log("Key background");
						$('.plus_btn img').attr('src',require('./../../../assets/images/plus.png'));
			    	}
				}    	

		    	if(parseInt($('.min_qty_btn input').val()) > parseInt(that.state.min_qty1)){
					$('.minus_btn img').attr('src',require('./../../../assets/images/minus_orange.png'));
		    	}    	

		    	if(parseInt($('.min_qty_btn input').val()) >= parseInt(that.state.max_qty1)){
					$('.plus_btn img').attr('src',require('./../../../assets/images/plus_fade.png'));
		    	}    	

		});
		$('.min_qty_btn input').keyup(function(e){
			if(e.keyCode == 8){
					$('.plus_btn img').attr('src',require('./../../../assets/images/plus.png'));	
			}
		}) 



		 
		var shareUrl = this.state.shareUrl;
    	var title = "Hey! Click here "+ shareUrl+" to check "+ this.state.pro_details.title  + " deal from AquaDeals.";
    	var description = shareUrl;
		var	swipe_product_attributes = this.state.swipe_product_attributes.map((product,index) => (<Details key={product.c_id} data={product} />));
		var views_cnt=this.state.offer.dealviews_count >=1 ? <span><img src={baseAssets+'images/web_imgs/pro_views_icon.png'} role="presentation" width="20px"/> {this.state.offer.dealviews_count}</span> : '';
		var rec_cnt=this.state.offer.recommended >=1 ? <span className="recommended_img"><img src={baseAssets+'icons/web_icons/like_icon.png'} width="17px" role="presentation"/> {this.state.offer.recommended}</span> : '';
		
        var rating =<ReactStars
                              count={5}
                              className={'webRate_blk_item'}
                              size={17}
                              value={this.state.rating >= 0 ? this.state.rating : 0}
                              edit={false}
                              color1={'#ccc'}
                              color2={'#ffc50a'} />

		var getcoupons='';
		if(this.state.coupons.length >0 )
		{
			getcoupons="coupons";
			const descriptionTop = (
				  <Popover id="popover-positioned-top">
					    {this.state.coupon_first.description}
				  </Popover>
			);
			const couponsList = (
				<Popover id="popover-positioned-top1">
					{this.state.cpns_list.replace(/,\s*$/, "")}
				</Popover>
			);
			if(this.state.coupons.length === 1)
			{
				getcoupons=<div className="row" style={{paddingTop:'10px',paddingBottom:'10px'}}>
				<div>
					<div className="mob_new_coupon_blk">
						<i className="coupon_left_img">
							<img  src={baseAssets+'icons/web_icons/coupon_left.png'} role='presentation' />
						</i>
						<div className="coupon_text">{this.state.coupon_first.coupon_code}</div>
						<OverlayTrigger trigger="focus" placement="top" overlay={descriptionTop}>
		   						<Button className="coupon_info_img"><img role="presentation" src={baseAssets+'icons/web_icons/coupon_info.png'} /></Button>
		   				</OverlayTrigger>
	   				</div>
				</div>
				</div>	
			}
			else
			{
				getcoupons=<div className="row" style={{paddingTop:'10px',paddingBottom:'10px'}}>
								<div className="col-md-6 col-xs-6 col-sm-6 col-md-offset">
									 <div className="mob_new_coupon_blk">
										<i className="coupon_left_img">
											<img alt=" " src={baseAssets+'icons/web_icons/coupon_left.png'} />
										</i>
										<div className="coupon_text">{this.state.coupon_first.coupon_code}</div>
										<OverlayTrigger trigger="focus" placement="top" overlay={descriptionTop}>
						   						<Button className="coupon_info_img"><img alt=" " src={baseAssets+'icons/web_icons/coupon_info.png'} /></Button>
						   				</OverlayTrigger>
					   					
					   				</div>
								</div>
								<div className="col-md-6 col-xs-6 col-sm-6" >
									<OverlayTrigger trigger="focus" placement="top" overlay={couponsList}>
										<Button className="applied_coupons">Applied coupons</Button>
									</OverlayTrigger>
								</div>
							</div>
			}
		}
		else
		{
			getcoupons='';
		}
		const params = {
	      paginationClickable: true,
	      spaceBetween: 10,
	      slidesPerView: 5
   		}
   		const deals_params ={
	   		paginationClickable: true,
		    spaceBetween: 10,
		    slidesPerView: 5,
		    // autoplay:3000,
	      	autoplayDisableOnInteraction:false,
	      	navigation: {
	            nextEl: '.swiper-button-next',
	            prevEl: '.swiper-button-prev'
	          }
   		}
   		var z=this.state.swipe_attributes_titles.map(function(name,index){
	                	return(<div className={this.state.swipe_attr_status === name.cid ? "swipe_attr_title_blk web_swipe_title_active" : "swipe_attr_title_blk"}>
	                		<div className={this.state.swipe_attr_status === name.cid ? "web_detail_head_active" : "web_detail_head"}><a className="product_att_titles" onClick={()=>this.getswipeDescription(this.props.params.Pid,name.cid)}>{name.title}</a>
	                		</div> 
	                	{/*{this.state.swipe_attr_status === name.cid ? <div className="arrow_indi1"><img src={baseAssets+'icons/web_icons/triangle_up.png'} alt=" " width="20px" /></div> : ''}*/}</div>);
	          }.bind(this));
		$('#req_quantity').keyup(function(){
			$('#req_quantity_err').text('');
		});
		$('#req_state').keyup(function(){
			$('#req_state_err').text('');
		});
		$('#req_city').keyup(function(){
			$('#req_city_err').text('');
		});
		$('#req_doorno').keyup(function(){
			$('#req_doorno_err').text('');
		});
		$('#req_pincode').keyup(function(){
			$('#req_pincode_err').text('');
		});

		var wishLst_flag='';
		if(this.state.wishLst_flag ===1)
		{
		    wishLst_flag=<div className="web_goto_wish_blk">
							<div className=''>
								<Link to={'/web/wishlist'}><i><img src={baseAssets+'images/web_imgs/wish_list_filled.png'} alt="" width="26px" style={{"marginRight":'-3px'}} title="GO TO WISHLIST" /></i>{/*Go to wishlist*/}</Link>
							</div>
						</div>;
		}
		else
		{
			wishLst_flag=<div className="web_addto_wish_blk">
							<div className=''>
								<Link onClick={()=>{this.addToWishlist()}}>
									<i><img src={baseAssets+'images/web_imgs/wish_list_unfilled.png'} alt="" width="20px" title="ADD TO WISHLIST" /></i>
								</Link>
							</div>
						</div>;
		}
		// var people_liked=<div>
		// 					<h4 className="dis_offers_h4">People who liked</h4>
		// 					<div>
		// 						<p>Liked by {this.state.brand_likes_count === 1 ? this.state.brand_likes_count +' user' : this.state.brand_likes_count+' users'}</p>
		// 						<div className="web_pro_liked_profile_blk">
		// 							{this.state.brand_like_users.map(function(data,index){
		// 								return(
		// 									<i className="web_pro_liked_profile_icon"><img src={baseAssets+'images/pro_pics/'+data.pro_pic} alt=" " width="50px" /></i>
		// 								)
		// 							}.bind(this))}
		// 							{this.state.brand_like_rem_count > 0 ? <span className="pro_liked_rem_count"><span>+{this.state.brand_like_rem_count}</span></span>: ''}
		// 						</div>
		// 					</div>
		// 				</div>;
		 
		var likes_btn=this.state.brand_like_status === '1' ? 
				<div onClick={()=>{this.likeBrand(0)}}>
				   <span  ><i className={"glyph_heart_active glyphicon glyphicon-heart"}></i></span>
			        {parseInt(this.state.brand_likes_count,10) === 1 ? <h6>{this.state.brand_likes_count+' Like'}</h6>: <h6>{this.state.brand_likes_count+' Likes'}</h6>}
			    </div>	
				:
				<div  onClick={()=>{this.likeBrand(1)}}>
				    <span ><i className={"glyph_heart glyphicon glyphicon-heart"}></i></span>
		            {parseInt(this.state.brand_likes_count,10) === 1 ? <h6>{this.state.brand_likes_count+' Like'}</h6> : <h6>{this.state.brand_likes_count+' Likes'}</h6>}
		         </div>;
		const ad_assist_data=( <Popover className="in" id="popover-positioned-top2">
										<p dangerouslySetInnerHTML={{__html: this.state.ad_grnt_str}}></p>
								</Popover>);

		var ad_assist_icon=this.state.ad_guarantee ===1 && this.state.ad_guarantee_icon ?  <OverlayTrigger trigger="focus" placement="top" overlay={ad_assist_data}>
								<Button className="web_ad_guarantee_icon"><img src={baseAssets+'images/product_imgs/'+this.state.ad_guarantee_icon} alt=" " /></Button>
							</OverlayTrigger> : '';

		var similar_brand_deals=this.state.similar_brand_deals.map(function(data,index){
			return(
			  <div className="col-md-3 col-sm-6">	
			    <div className={data.title === "View More" ? "web_sw_view_more1" : ""} >
				  <div className="prdt_blk">	
					{data.title === "View More" ?
				  	<a href={"/web/pdeals/"+data.url_dtype_name+'/'+data.url_cat_name+'/'+this.state.pro_details.category_id+'/Pcategory/'+data.dtype}>
						{data.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+data.promo_ribbion } alt="" /></i> : ''}
					    <div>
						   {data.image ==='' ? '' : <i className="sim_deal_img"><img src={baseAssets+'images/product_imgs/'+data.image} alt=" " /></i>}
	    				</div>
	    				{data.title ? <h3>{data.title}</h3> : <h3>&nbsp;</h3>}
	    				{data.brand_name ? <h4>{data.brand_name}</h4> : <h4>&nbsp;</h4>}
		    			{data.mrp ? <h4>MRP ₹ {data.mrp}</h4> :<h4>&nbsp;</h4>}
					</a>
                    : 
                   <a href={'/web/pdetails/'+data.url_dtype_name+'/'+data.url_cat_name+'/'+data.url_brand_name+'/'+data.url_product_name+'/'+data.pid+'/'+data.deal_id}> 
	    			   <div>	
	    				{data.image ==='' ? '' : <i className="sim_deal_img"><img src={baseAssets+'images/product_imgs/'+data.image} alt=" " /></i>}
	    			   </div>	
	    				{data.title ? <h3>{data.title}</h3> : <h3>&nbsp;</h3>}
	    				{data.brand_name ? <h4>{data.brand_name}</h4> : <h4>&nbsp;</h4>}
		    			{data.mrp ? <h4>MRP ₹ {data.mrp}</h4> :<h4>&nbsp;</h4>}
	    			</a> 
                  }
	    		</div>
	    	  </div>	 
	        </div>		
	      )
		}.bind(this));
		
		var similar_category_deals=this.state.similar_category_deals.map(function(data,index){
			return(
			 <div className="col-md-3 col-sm-6">	
				<div className={data.title === "View More" ? "web_sw_view_more1" : ""} >
				  <div className="prdt_blk">	
					{data.title === "View More" ?
					<a href={"/web/pdeals/"+data.url_dtype_name+'/'+data.url_cat_name+'/'+this.state.pro_details.category_id+'/Pcategory/'+data.dtype}>
						{data.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+data.promo_ribbion } alt="" /></i> : ''}
                       <div>
						{data.image ==='' ? '' : <i className="sim_deal_img"><img src={baseAssets+'images/product_imgs/'+data.image} alt=" " /></i>}
	    			   </div>	
	    				{data.title ? <h3>{data.title}</h3> : <h3>&nbsp;</h3>}
	    				{data.brand_name ? <h4>{data.brand_name}</h4> : <h4>&nbsp;</h4>}
		    			{data.mrp ? <h4>MRP ₹ {data.mrp}</h4> :<h4>&nbsp;</h4>}
					</a> : 
					<a href={'/web/pdetails/'+data.url_dtype_name+'/'+data.url_cat_name+'/'+data.url_brand_name+'/'+data.url_product_name+'/'+data.pid+'/'+data.deal_id}> 
	    				<div>
	    				  {data.image ==='' ? '' : <i className="sim_deal_img"><img src={baseAssets+'images/product_imgs/'+data.image} alt=" " /></i>}
	    				</div>
	    				{data.title ? <h3>{data.title}</h3> : <h3>&nbsp;</h3>}
	    				{data.brand_name ? <h4>{data.brand_name}</h4> : <h4>&nbsp;</h4>}
		    			{data.mrp ? <h4>MRP ₹ {data.mrp}</h4> :<h4>&nbsp;</h4>}
	    			</a> }
	    		  </div>	
	    		</div>
	    	 </div> 	
			)
		}.bind(this));
		
		var similar_stage_deals=this.state.similar_stage_deals.map(function(data,index){
			return(
			  <div className="col-md-3 col-sm-6">
				<div className={data.title === "View More" ? "web_sw_view_more1" : ""} >
				   <div className="prdt_blk">	
					  {data.title === "View More" ?
						 <a href={"/web/pdeals/"+data.url_dtype_name+'/'+data.url_cat_name+'/'+this.state.pro_details.category_id+'/Pcategory/'+data.dtype}>
							{data.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+data.promo_ribbion } alt="" /></i> : ''}
						   <div>
							{data.image ==='' ? '' : <i className="sim_deal_img"><img src={baseAssets+'images/product_imgs/'+data.image} alt=" " /></i>}
		    			   </div>	
		    				{data.title ? <h3>{data.title}</h3> : <h3>&nbsp;</h3>}
		    				{data.brand_name ? <h4>{data.brand_name}</h4> : <h4>&nbsp;</h4>}
			    			{data.mrp ? <h4>MRP ₹ {data.mrp}</h4> :<h4>&nbsp;</h4>}
						</a> : 
						<a href={'/web/pdetails/'+data.url_dtype_name+'/'+data.url_cat_name+'/'+data.url_brand_name+'/'+data.url_product_name+'/'+data.pid+'/'+data.deal_id}> 
		    			   <div>	
		    				 {data.image ==='' ? '' : <i className="sim_deal_img"><img src={baseAssets+'images/product_imgs/'+data.image} alt=" " /></i>}
		    			   </div>	
		    				{data.title ? <h3>{data.title}</h3> : <h3>&nbsp;</h3>}
		    				{data.brand_name ? <h4>{data.brand_name}</h4> : <h4>&nbsp;</h4>}
			    			{data.mrp ? <h4>MRP ₹ {data.mrp}</h4> :<h4>&nbsp;</h4>}
		        	   </a> 
                      }
	    	      </div> 	
	    	   </div>
	    	  </div>
			)
		}.bind(this));

		return (
			<div className="web_Deals web_pro_full_details_page" itemScope="itemScope" itemType="http://schema.org/Product"> {this.state.loading && !this.state.page_error_status ? 
				<div className="lgt_gry">
						<WebHeaderInner cart_updated_count={this.state.cart_count} />
						<div className="clr">&nbsp;</div>
						<div className="clr">&nbsp;</div>
						<div className="clr">&nbsp;</div>
						<div className="clr">&nbsp;</div>
						<div className="clr">&nbsp;</div>
						<div className="clr">&nbsp;</div>
						<section className="container">
						   <div className="">
						     <div className="row">
								<Breadcrumb className="pro_ful_dtls_breadcrumb">
							    	<Breadcrumb.Item href="/web/home">Home</Breadcrumb.Item>
									<Breadcrumb.Item href={'/web/pdeals/'+this.state.brand_name+'/all/'+this.state.dtype}>{this.state.brand_name}</Breadcrumb.Item>
									<Breadcrumb.Item href={'/web/pdeals/'+this.state.brand_name+'/'+this.state.cat_name+'/'+this.state.bread_tid+'/Pcategory/'+this.state.d_type_bread}>{this.state.cat_name}</Breadcrumb.Item>
									<Breadcrumb.Item active>{this.state.pro_details.title} {this.state.pro_details.unit_pack}</Breadcrumb.Item>
							    </Breadcrumb> 
							   </div> 
							</div>
						    {/*<!-- product details start -->*/}
						    <div className="row pro_dtls">
								<div className="col-md-4">
								   {wishLst_flag}
								   <Swiper {...carousel_params}>
      								{product_imgs}
      							</Swiper>
		                        </div>
                                <div className="col-md-8">
                                   <div className="pro_info">
									  {this.state.pro_details.title ? <h3 itemProp="name">{this.state.pro_details.title} {this.state.pro_details.unit_pack}</h3> : ''}
									  <Link className="share_btn" onClick={()=>{this.ShareFunc(this.state.deal_did)}}>
									      <i><img src={baseAssets+'images/web_imgs/share_icon.png'} alt="share" width="19px" /></i>
								      </Link>
								      <div className="web_full_share_panel">
											<Panel collapsible expanded={this.state.open}>
										    	<FacebookShareButton url={shareUrl} quote={title} description={description} className="test_share1">
										        	<FacebookIcon size={32} round />
										    	</FacebookShareButton>
										        <TwitterShareButton url={shareUrl} quote={title} description={description} className="test_share1">
										           <TwitterIcon size={32} round />
										        </TwitterShareButton>
												<GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share1">
										    	     <GooglePlusIcon size={32} round />
										        </GooglePlusShareButton>
											</Panel>
								     </div> 
							         <div className="clr">&nbsp;</div>
							         	{this.state.pro_details.brand_name ? <h4><span itemProp="brand">{this.state.pro_details.brand_name}</span></h4> : ''}
							         	<div className="star_view_like">
										    <ul>
										      <li><span>{rating}</span>&nbsp;<span>{this.state.rating  ? (this.state.rating) : ''}</span></li>
										      {views_cnt ? 
										       <li><span>{views_cnt}</span></li>
										       :
										       ''
										      }
										      {rec_cnt ?
										      <li><span>{rec_cnt}</span></li>
										      :''}
										      <li><span className="brand_flag_img"><img src={"https://aquadeals.in/admin/assets/icons/"+this.state.pro_details.brand_flag} role="presentation" /></span>&nbsp;</li>
										    </ul>
										    <div className="ad_gurnted">
										      {ad_assist_icon}
										    </div>
										  </div>
										   <div className="ordr_cnt">
										    {this.state.show_order_count_flag === 1 ? <p><img src={baseAssets+'images/web_imgs/hot_sale.png'} alt="" width="16px" /> {this.state.order_msg}</p>:<p>&nbsp;</p>}
									       </div>
									</div>
								    {/*<!-- pric_ofers start --> */}
								    <div className="pric_ofers">
									  <div className="col-md-6">
										{/*<!-- price block start -->*/}
										 <div className="pro_pric_blk">
                                             {this.state.pro_deal_details.mrp ? <h5 itemProp="offers" itemScope itemType="http://schema.org/Offer"><meta itemProp="priceCurrency" content="INR" />Rs. <span></span> <span itemProp="price">{this.state.pro_deal_details.mrp}</span></h5> : ''} 
										 </div>
										{/*price block end*/}
									    {/*<!-- coupon block start -->*/}
											<div className="cupn_blk">
											  {this.state.coupons.length > 0 ? <div><h4 className="web_coupon_h4">Coupons </h4><div className="coupons_list">{getcoupons}</div></div> :''}
											</div>
											{/*<!-- coupon block end -->*/}
									  </div>
									  <div className="col-md-6 dscnt_ofrs">
										<h4>Discount &amp; Offers</h4>
										  <div className="dscnt_ofrs_blk">
										    {/*<ul>
										      <li>{this.state.offer_details.aqua_cash_title ? <h5 className="book_aquacash"><i className="bookcsh"><img className="newaquacash_icon" src={baseAssets+'icons/web_icons/nav_aquacash.png'} alt=" " /></i>{this.state.offer_details.aqua_cash_title}</h5> : <div className="aqua_cash_title_not"></div>}</li>
											  <li>{this.state.offer_details.full_aquacash_back_title ? <h5 style={{color:'#666666'}}><i><img className="full_aquacash_back_title" src={baseAssets+'icons/web_icons/newcashback.png'} alt=" " /></i>{this.state.offer_details.full_aquacash_back_title}</h5> : ''} </li>
											  <li>{this.state.offer_details.pur_ern_ofr_desc ? <h5 className="book_aquacash"><i><img className="newaquacash_icon" src={baseAssets+'icons/web_icons/nav_aquacash.png'} alt=" " /></i>{this.state.offer_details.pur_ern_ofr_desc}</h5> : ''}</li>
											  <li>{this.state.offer_details.emi_opt_sts === 1 ? <h5 className="web_emi"><i><img src={baseAssets+'icons/web_icons/emi.png'} alt=" "  width="20px"/></i>{this.state.offer_details.emi_opt_desc}</h5> : ''}</li>
										    </ul>*/}
										    <div className="row web_dis_ofr_blk">
										    	<div className="col-lg-1 web_dis_ofr_lft">{this.state.offer_details.aqua_cash_title ? <i className="bookcsh2"><img className="newaquacash_icon2" src={baseAssets+'icons/web_icons/nav_aquacash.png'} alt=" " /></i> : ''}</div>
										    	<div className="col-lg-11 web_dis_ofr_rgt">{this.state.offer_details.aqua_cash_title ? this.state.offer_details.aqua_cash_title : ''}</div>
										    	<div className="col-lg-1 web_dis_ofr_lft">{this.state.offer_details.full_aquacash_back_title ? <i><img className="full_aquacash_back_title2" src={baseAssets+'icons/web_icons/newcashback.png'} alt=" " /></i> :''}</div>
										    	<div className="col-lg-11 web_dis_ofr_rgt">{this.state.offer_details.full_aquacash_back_title ? this.state.offer_details.full_aquacash_back_title : ''}</div>
										    	<div className="col-lg-1 web_dis_ofr_lft">{this.state.offer_details.pur_ern_ofr_desc ? <i><img className="newaquacash_icon2" src={baseAssets+'icons/web_icons/nav_aquacash.png'} alt=" " /></i> : ''}</div>
										    	<div className="col-lg-11 web_dis_ofr_rgt">{this.state.offer_details.pur_ern_ofr_desc ? this.state.offer_details.pur_ern_ofr_desc : ''}</div>
										    	<div className="col-lg-1 web_dis_ofr_lft">{parseInt(this.state.offer_details.emi_opt_sts) === 1 ? <i><img src={baseAssets+'icons/web_icons/emi.png'} alt=" " width="20px"/></i> : ''}</div>
										    	<div className="col-lg-11 web_dis_ofr_rgt">{parseInt(this.state.offer_details.emi_opt_sts) === 1 ? this.state.offer_details.emi_opt_desc : ''}</div>
										    </div>
										  </div>
										</div>
									 </div>	
									   {/*price offers end*/}
									   {/*<!-- qty_delvr start --> */}
									    <div className="qty_delvr row">
											 <div className={this.state.free_shipment === 1 ? "col-md-6 col-sm-6" : 'col-md-12'}>
												  <div className="qty_blk col-md-12" style={{padding:'0px'}}>
												  <div>
												  	<div className="col-md-12" style={{padding:'0px'}}>
												  	<ul style={{display: 'flex',justifyContent: 'center'}}>
														  {this.state.free_shipment === 1? 
															  <h5>Quantity</h5>
															: 
															  <h4>Quantity</h4>															  
														  }	

														{this.state.unit_name==="kg" || this.state.unit_name ==="gm" ?  
					 										<ul>
															    <li><button className="minus_btn" onClick={()=>{this.decrementMinQty()}}><img src={require('./../../../assets/images/minus_orange_fade.png')} alt=" " /></button></li>
															    <li className="min_qty_btn"><input type="text" placeholder={this.state.min_qty1} value={this.state.min_qty} ref="input_minqty" onChange={this.updateMinQty}/></li>
															    <li><button className="plus_btn" onClick={()=>{this.incrementMinQty()}}><img src={baseAssets+'icons/web_icons/plus.png'} alt=" " /></button></li>
															    <li><span className="equl_to">=</span></li>
															    <li className="cunt_van">
															    <p><span className="web_qty_mainvalue">{this.state.tons}</span>
															    <span className="qty_unitname">Tons</span></p>
															    <img src={baseAssets+'icons/web_icons/truck.png'} role="presentation" /></li>
															</ul>
															:
															<ul>
															    <li><button className="minus_btn" onClick={()=>{this.decrementMinQty()}}><img src={require('./../../../assets/images/minus_orange_fade.png')} alt=" " /></button></li>
															    <li className="min_qty_btn"><input type="text" placeholder={this.state.min_qty1} value={this.state.min_qty} ref="input_minqty" onChange={this.updateMinQty}/></li>
															    <li><button className="plus_btn" onClick={()=>{this.incrementMinQty()}}><img src={baseAssets+'icons/web_icons/plus.png'} alt=" " /></button></li>
															</ul>	
														}
												  	</ul> 
												  	</div>
												  </div>

												  </div>
												  {this.state.qty_err_status ? <p className="web_err_quantity">{this.state.qty_err_msg}</p> : ''}
												  			
												  <div className="web_prev_order_text">
														{this.state.previous_order === '' ? '' : this.state.previous_order}
													</div>
											  </div>
											  <div className="col-md-6 col-sm-6">
											    {this.state.free_shipment === 1 ?  
												   <div> 
												    <div className="delvry_blk">
												      <h4>Delivery</h4>
												      {this.state.free_shipment === 1 ?  
												      <div className="pin_blk">
												        <input type="text" name="pin code" placeholder="Enter pincode" value={this.state.user_zipcode==='0' ? '' : this.state.user_zipcode} maxLength={6} ref="pincode" onChange={()=>{this.pincodeChange()}}/>
												        <button onClick={()=>{this.checkPincode()}}>CHECK</button>
												      </div>
												       :''} 
												    </div>
												      {this.state.err_pincode ? <p className="error">{this.state.err_pincode_msg}</p>:''}
												      {this.state.free_ship_msg ? <p className={this.state.err_pincode ? 'hide' : "free_ship_msg"}>{this.state.free_ship_msg}</p>:''}
												   </div> 
											    :
											    ''} 
											 </div>
										</div>
									  {/*<!-- qty_delvr end --> */}
									 {/*<!-- cart_btns start -->*/}
										<div className="col-md-10 col-md-offset-1 price_cart_btns">
										  <div className="col-md-6 col-sm-6">
										    <button className="best_price_btn" onClick={()=>{this.addQCart(this.state.deal_did)}}><i><img src={baseAssets+"images/web_imgs/quick_buy.png"} role="presentation" /></i><span>Quick Buy</span></button>
										  </div>
										  <div  className={this.state.rotateClass ? "col-md-6 col-sm-6 web_rotate_true" :"col-md-6 col-sm-6 web_rotate_false"}>
										    <button className="add_cart_btn"  onClick={()=>{this.placeOrderModal()}}><span>{this.state.addtocart_msg}</span></button>
										  </div>
										</div>
								   {/* <!-- cart_btns end --> */}

									 </div>
									 <div className="clr">&nbsp;</div>
									{/* <!-- about brand start --> */}
									 <div className="abt_brnd">
									   <div className="col-md-6 col-sm-6 rgt_brdr">
									      <div className="brnd_dtls">
									        <div className="brnd_dtls_lft"> 
									          <Link className="web_pro_abt_link" to={this.state.pro_details ? '/web/'+this.state.pro_details.url_brand_name+'/brand-details/'+this.state.offer.bid :'#'}>
									            <img className="media-object" src={this.state.pro_details ? baseAssets+'images/brand_icons/'+this.state.pro_details.brand_logo : ''} alt=" " width={"100px"}/>
									          </Link>
									        </div>
                                            <div className="brnd_dtls_rgt">
                                              <Link className="web_pro_abt_link" to={'/web/'+this.state.pro_details.url_brand_name+'/brand-details/'+this.state.offer.bid}>
									            {this.state.pro_details.brand_name ? <h4>{this.state.pro_details.brand_name}</h4> : <h4>&nbsp;</h4>}
									            {this.state.brand_desc ? <h5 className="brand_desc">{this.state.brand_desc}</h5>:<h5>&nbsp;</h5>}
									          </Link>
									        </div>
                                            <div className="brnd_like">
									           {likes_btn}
									        </div>
                                         </div>
									   </div>
									   <div className="col-md-6 col-sm-6">
									      <div className="row">
									        <div className="col-md-6 col-sm-6 rgt_brdr">
									          <div className="ad_icons" onClick={() => this.getAdAssistModal()}>
									            <img src={baseAssets+'images/web_imgs/ad_assist_icon_5.png'} role="presentation"/>
									            <h6>AD Assist</h6>
									          </div>
									        </div>
									        <div className="col-md-6 col-sm-6">
									          <div className="ad_icons" onClick={()=>{this.checkBestPrice()}}>
									            <img src={baseAssets+"images_web/get_best_price.png"} role="presentation" />
									            <h6>Get Best Price</h6>
									          </div>
									        </div>
									      </div>
									   </div>
									</div>
									{/*<!-- about brand end -->*/}
									
								     { /*  <!-- product description start --> */}
								     {this.state.product_tabs_avail ?  
								      <div className="pro_des">
										 <div className="col-md-12"><h2>Details</h2></div>
										  <div className="pro_des_tb_cnt">
											 	<div className="col-md-12 col-sm-12 col-xs-12" style={{marginTop:'5px'}}>
											  	  <div className="desc_swipeblock">
													  <Swiper {...params}>
															{z}
													  </Swiper>
													  <div className="tab-content">	
														{this.state.swipe_desc_info ? <div>
															<div className="row web_description_blk" >
																{this.state.swipe_desc_info ?
																	<section className="mob_pro_desc">
																	        <div dangerouslySetInnerHTML={{
																				    __html: this.state.swipe_desc_info
																			}}></div>

																	</section> 

																: ''}
															</div>
														</div> : ''}
														   {swipe_product_attributes.length > 0 ? 
														   <div className="row">
																	<div className="col-md-12 col-xs-12 col-sm-12 web_description_cntnt">
																	{this.state.pro_details.description ? <p itemProp="description" style={{fontSize:'11px'}} dangerouslySetInnerHTML={{__html: this.state.pro_details.description}}></p> : ''}
																		<table>
																			{swipe_product_attributes}
																		</table>
																	</div>
															</div> : ''}
														</div>		
												    </div>
											   </div>
										    </div>
									  </div>
									  :""}
										{/*<!-- product description end -->*/}
                                       {/* similar products start*/}
                                        <div className="pro_des similar_tabs">
									        <div className="col-md-12 "><h2>Similar Deals</h2></div>
	                                            <div className="pro_des_tb_cnt">
	                                                <div className="col-md-12 websimilar_blk">
                                                         {/*  Similar Brands Ends here */}
													  	 {this.state.brand_sim_flag === 1 ? 
															<div className="col-md-4 col-sm-4" onClick={()=>{this.getSimilarBrandDeals()}}>
																<div className={this.state.similar_brand_deals_status ? "similar_tab_item  border_active":"similar_tab_item"}>	
																	<i><img src={require('./../../../assets/images/view_similar1.png')} alt="..." width="40" /></i> More deals from {this.state.pro_details.brand_name} 
															 	</div>
															</div> : ''
														  }
														  {/*  Similar Category Starting here */}
														  {this.state.cat_sim_flag === 1 ? 
														  	 <div className="col-md-4 col-sm-4"  onClick={()=>{this.getSimilarCatDeals()}}>
																<div className={this.state.similar_category_deals_status  ? "similar_tab_item border_active":"similar_tab_item"}>
																 <i><img src={require('./../../../assets/images/view_similar2.png')} alt="..." width="40" /></i> More deals in {this.state.pro_details.category} 
															    </div>
															 </div> : ''
														  }
														  {/*  Similar Stage Starting here */}
														  {this.state.stage_sim_flag === 1 ? 
															 <div className="col-md-4 col-sm-4"  onClick={()=>{this.getSimilarStageDeals()}}>
																<div className={this.state.similar_stage_deals_status ? "similar_tab_item  border_active":"similar_tab_item"}>
																 <i><img src={require('./../../../assets/images/view_similar3_1.png')} alt="..." width="40" /></i>View Similar Stage 
															    </div>
															  </div>: ''
														  }
													</div>
													<div className="pro_sld_ctrls lr_chiv">
														<a className="left carousel-control pro_sld_lft" onClick={this.goPrev}>
												          <span className="pro_sld_arow"><img src={baseAssets+'images_web/left_arrow.png'} alt="" /></span>
												          <span className="sr-only"></span>
												        </a>
												        <a className="right carousel-control pro_sld_rgt" onClick={this.goNext}>
												          <span className="pro_sld_arow"><img src={baseAssets+'images_web/right_arrow.png'} alt="" /></span>
												          <span className="sr-only"></span>
												        </a>
											        </div>	  
												</div>
												<div className="total_similars" >
													<div className="container">		
													    <div className="row">		
															{this.state.similar_brand_deals_status ? 
																<div className="Similar_Deals_Blk">
																	<Swiper {...deals_params} key={similar_brand_deals.length} ref={node => node ? this.swiper = node.swiper : ''} >
																		{similar_brand_deals}
																	</Swiper>
																</div>
															: ''}
															{this.state.similar_category_deals_status ?
															     <div className="Similar_Deals_Blk">
																	<Swiper {...deals_params} key={similar_category_deals.length} ref={node => node ? this.swiper = node.swiper : ''}>
																		{similar_category_deals}
																	</Swiper>
																</div> 
														    : ''}
														    {this.state.similar_stage_deals_status ? 
																<div className="Similar_Deals_Blk">
																	<Swiper {...deals_params} key={similar_stage_deals.length} ref={node => node ? this.swiper = node.swiper : ''} >
																		{similar_stage_deals}
																	</Swiper>
																</div> 
														 : ''}
												        </div>
												     </div>   
										        </div>  		
							            </div>
                                       {/*similar products end*/}

										{this.state.disclaimer_flag ?
											<section>
								  				<span id="disclaimer_toggle_txt"><a onClick={()=>{this.toggleDisclaimer()}}>{this.state.visibility ? "Hide Disclaimer" : "View Disclaimer"}</a></span>											
								  			<div className="view_disclaimer_details">
								  				{this.state.visibility ? <div className="disclaimer_txt_container"><span id="mob_disclaimer_txt" dangerouslySetInnerHTML={{ __html: this.state.disclaimer_txt}}></span></div> : ''}
								  			</div></section> : ''		  					  			
							  			}                                       

                                       <Modal className="showModal" show={this.state.showModal} onHide={this.close}  >
											<Modal.Header closeButton>
								            		<Modal.Title style={{fontSize: 16+'px',color:'#333'}}>AquaDeals</Modal.Title>
								        	</Modal.Header>
								        	<Modal.Body>
								          			<h4 style={{fontSize:14+'px', color:'#666'}}>You need to install Android mobile app to place order.</h4>
								        	</Modal.Body>
								        	<Modal.Footer className="modal_footer">
								        		<Button style={{background: '#fff none repeat scroll 0 0',color:'#ff742a',marginRight:'5px'}} onClick={this.close}>Close</Button>
								        		<a href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en" target="_blank" title=""><Button style={{background: '#ff742a none repeat scroll 0 0',color: '#fff'}}>OK</Button></a>
								        	</Modal.Footer>
										</Modal>
										{/*<Modal className="m_pro_full_dtls_modal"  show={this.state.reqbestPrice} onHide={this.close}  >
												<Modal.Header closeButton>
										    		<Modal.Title style={{fontSize: 16+'px',color:'#333'}}>AquaDeals</Modal.Title>
										  		</Modal.Header>
										  		<Modal.Body>
										  			<h4 style={{fontSize:14+'px', color:'#666'}}>You need to install Android mobile app to get best price.</h4>
										  		</Modal.Body>
										  		<Modal.Footer className="modal_footer">
													<Button style={{background: '#fff none repeat scroll 0 0',color:'#ff742a'}} onClick={this.close}>Close</Button>
													<a href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en" target="_blank" title=""><Button style={{background: '#ff742a none repeat scroll 0 0',color: '#fff'}}>OK</Button></a>
										  		</Modal.Footer>
										</Modal> */}
										<Modal className="m_pro_full_dtls_modal"  show={this.state.clearcart_status} onHide={this.close}  >
											<Modal.Header closeButton>
									    		<Modal.Title style={{fontSize: '16px',color:'#333'}}>Alert</Modal.Title>
									  		</Modal.Header>
									  		<Modal.Body>
									  			<h4 style={{fontSize:'14px', color:'#666'}}>You can't have multiple seller items in the cart.Empty existing cart & add this item {this.state.pro_details.title}?</h4>
									  		</Modal.Body>
									  		<Modal.Footer className="modal_footer">
									  				<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>NO</Button>
									  				<a><Button style={{background:'none',border:'none',color: '#ff742a'}} onClick={()=>{this.removeCartItems()}}>YES</Button></a>
									  		</Modal.Footer>
										</Modal>
							  			<Modal className="mob_reqbestprice"  show={this.state.reqbestPrice} onHide={this.close}  id="ad_best_price_web">
											<Modal.Body>
												<section className="bst_header_block" style={{textAlign:'center'}}>
												<h4 className="req_title">REQUEST FOR BEST PRICE</h4>
												<span onClick={this.close}><Icon
								                    name='close'
								                    font='SimpleLineIcons'
								                    color='#333'
								                    size={16}
								                    style={{position:'absolute',right:'10px',top:'8px',cursor:'pointer'}}
								                  />
								                </span>
												<img  src={require('./../../../assets/images/bp_icn_pro.png')} width="100" alt="" />					

												<p className="req_desc"><span dangerouslySetInnerHTML={{ __html: this.state.best_price_txt}}></span></p>
									  			</section>
									  			<form className="req_best_price_form" onSubmit={this.reqBestPriceSubmit} >
									  				<input type="text" maxLength={10} id="req_quantity" ref="req_quantity" value={this.state.req_quantity} onChange={this.req_quantityChange} placeholder="Enter Quantity" />
									  				<span className="req_err" id="req_quantity_err"></span>
									  				<input type="text" ref="req_state" id="req_state" value={this.state.req_state} onChange={this.req_stateChange} placeholder="Enter State" />
									  				<span className="req_err" id="req_state_err"></span>
									  				<input type="text" maxLength={6} ref="req_pincode" id="req_pincode" value={this.state.req_pincode} onChange={this.req_pincodeChange} placeholder="Pincode" />
									  				<span className="req_err" id="req_pincode_err"></span>
									  				<div className="req_footer">
									  					<button type="submit">SUBMIT</button>
									  				</div>
									  			</form>
									  		</Modal.Body>
									  	</Modal>
									  	<Modal className="mob_reqbestprice_confm"  show={this.state.req_confirm_modal} onHide={this.close}>
											<Modal.Body>
												{this.state.req_confirm_message}
												<a onClick={this.close} className="req_conf_ok_btn">OK</a>
									  		</Modal.Body>
									  	</Modal>									  	
										  	<Modal className="ad_asst_modalbox" show={this.state.ad_assist_modal} onHide={this.close} id="ad_assist_web">
										  		<Modal.Body>
													<section id="assets_cnt_block">
															<span onClick={this.close}><Icon
											                    name='close'
											                    font='SimpleLineIcons'
											                    color='#fff'
											                    size={16}
											                    style={{position:'absolute',right:'10px',top:'8px',cursor:'pointer'}}
											                  />
											                </span>
														<img  src={require('./../../../assets/images/ad_assest_pop_icon.png')}  alt="" />					
														<p>Please submit the details, one of our experts will respond shortly.</p>
												  	<section className="ad_prd_blocks">
												  		<p><span className="orng_clr">Brand: </span>{this.state.pro_details.brand_name ? this.state.pro_details.brand_name : ''}</p>
											  			<p><span className="orng_clr">Product: </span> {this.state.pro_details.title ? this.state.pro_details.title : ''}</p>						      
												    </section>  
												      <div className="aqua-txt-block">
													      <select id="ad-sel-question">
													        {this.state.queries.map((option) => <option key={option.id} value={option.id}>{option.question}</option>)}
													      </select>
													  	  <h6>Best time to contact:  {this.state.time_err_status ? <span style={{color:'red',fontSize:'10px'}}>{this.state.time_err_msg}</span> : ''}</h6>		
									  			<form onSubmit={this.submitAdAssistData}>
										  			<div className="ad_asst_time_blk">
										  				<span className={this.state.ad_asst_time === 1 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time"} onClick={()=>{this.setAdTime(1)}}>9am - 12pm</span>
										  				<span className={this.state.ad_asst_time === 2 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time"} onClick={()=>{this.setAdTime(2)}}>12pm - 3pm</span>
										  				<span className={this.state.ad_asst_time === 3 ? "ad_asst_time ad_asst_time_active" : "ad_asst_time"} onClick={()=>{this.setAdTime(3)}}>3pm - 5pm</span>
										  			</div>
													<div className="ad_asst_submit_blk">
														{/*<button type="button" onClick={this.close}>CANCEL</button>*/}
														<button type="submit">SCHEDULE CALL</button>
													</div>
												</form>								  	            
												      </div>
													</section>
										  		</Modal.Body>
										  	</Modal>
									  	<Modal className="mob_reqbestprice_confm"  show={this.state.ad_asst_confirm_modal} onHide={this.close}  >
											<Modal.Body>
												{this.state.ad_asst_confirm_message}
												<a onClick={this.close} className="req_conf_ok_btn">OK</a>
									  		</Modal.Body>
									  	</Modal>
						          
					          </div> 	 

                          </section>
                          <WebFooter />	
					</div> : <div>{this.state.page_error_status ?  <Web_NotFound /> : <div className="loading_sym" style={{width:100+'%',textAlign:'center',marginTop:20+'%'}}><img src={baseAssets+'images/web_imgs/ajax-loader1.gif'} alt="Loading Deals" role="presentation" /> </div>}</div>}</div>
				);
			}
		}

class Details extends Component{
	render(){
		var mydata=this.props.data;
		return(
				<tr>
					{mydata.value !== '--' ? <td>{mydata.name}</td> :'' }
					{mydata.value !== '--' ? <td className="desc_right">{mydata.value}</td> : ''}
				</tr>
		);
	}
}
function mapStateToProps(state){
  return {
	leads:state.posts.leads, 
    formdata:state.auth.formdata,
	formdata_log:state.auth.formdata_log,
    product_tabs: state.posts.product_tabs,
    product_desc: state.posts.product_desc,    	
  };
}
export default connect(mapStateToProps,actions)(Web_ProductFullDetails);										


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Feed/Web_product_full_details.js
 **/